const tw = {
  on: {
    useSafari: '請用手機瀏覽器打開這個連結',
    callApp: 'Call App'
  },
  order: {
    allOrders: '全部訂單',
    activeOrders: '進行中的訂單',
    historyOrders: '歷史訂單',
    realCount: '實付',
    orderDetails: '訂單詳情',
    created: '已創建',
    acceptedOrder: '你接單了',
    orderCompleted: '訂單完成',
    Confirmorder: '是否確認接單？',
    Ordercanceled: '訂單取消',
    Rejectorder: '拒絕訂單',
    Rejectcancellation: '是否拒絕接單？',
    OnceConfirmorder: '接單之後，你就沒法取消訂單了喔。確認接單嗎？',
    responseto: '你沒有在10分鐘內接',
    gotit: '知道了',
    automaticallycanceled: '的訂單，訂單取消',
    YesCancel: '確認取消',
    YesCompleted: '確認完成',
    Yes: '確認',
    cancelOrder: '取消訂單',
    thinkAgain: '再想想',
    Orderconfirmed: '訂單已確認',
    rejectorder: '拒絕的話訂單就馬上會被取消喔，真的要狠心拒絕嗎？',
    Orderrejected: '訂單被拒絕',
    rejectcancellation:
      'Once you reject the cancellation request, the order will be in dispute and officially arbitrated. Still reject the cancellation request?',
    Successful: '成功了！',
    Successfully: '成功了！',
    noorders: '暫無訂單',
    acceptcancellation:
      'Once you accept the cancellation request, the order will be canceled immediately. Still accept the cancellation request?',
    Reject: '拒絕',
    Confirming: '待接單',
    inProgress: '進行中',
    cancellationRequest: '申訴中',
    Dispute: '申訴中',
    Confirm: '確認',
    active: '活躍訂單',
    history: '歷史訂單',
    completed: '完成',
    acceptedorder: '陪玩師接單了',
    Writereview: '寫評論',
    Tapstars: '點亮星星給陪玩師評論喔',
    Surecancelorder: '是否取消訂單？',
    Surecompleteorder: '是否完成訂單？',
    reachedagreement: '客訴前請好好跟陪玩師溝通喔',
    permenantlyclosed: '確認要取消訂單嗎？',
    completeorder: '完成訂單後就沒法退款了喔',
    confirmacceptorder: '確認要取消訂單嗎？',
    Order: '訂單編號',
    canceled: '取消',
    Play: '一起玩',
    with: '和',
    Quantity: '數量',
    Subtotal: '總價',
    Discount: '優惠券扣減',
    Total: '實付',
    purchaseSkill: '購買技能',
    Note: '備註',
    CompleteOrder: '完成訂單',
    Orders: '訂單',
    myorder: ' 我的訂單',
    Received: '陪玩訂單',
    Placed: '我的訂單',
    Acceptcancellation: '是否接受取消申請？'
  },
  follow: {
    FollowList: '追蹤',
    Following: '追蹤列錶',
    Follower: '粉絲列錶',
    Follow: '粉絲',
    Followers: '粉絲',
    followyourself: '不能追蹤你自己喔',
    unfollow: '確定取消追蹤',
    tokenLost: 'Token Lost',
    noPlayerID: 'No PlayerID',
    End: 'End',
    nofollowers: '還沒有粉絲唷',
    nofollowing: '還沒有追蹤的陪玩師，快去首頁看看唷'
  },
  player: {
    wirteReview: '寫評論',
    Review: '用戶評價',
    Reviews: '用戶評價',
    SeeMore: '展開',
    Skills: '技能項目',
    localtime: '當地時間',
    Buy: '下單',
    gamers: '陪玩師',
    moreSkills: '更多技能項目',
    findGamers: '發現更多陪玩師',
    noratings: '還沒有評論喔',
    SeeAll: '查看全部',
    Showmore: '快來豐富一下你的個人資料喔',
    suchempty: '空蕩蕩～',
    editprofile: '編輯個人資料',
    Followed: '已追蹤',
    Unfollow: '取消追蹤',
    Cancel: '取消'
  },
  skill: {
    Add: '添加技能',
    Skills: '技能項目管理',
    finishSetting: '完成設定',
    Verifying: '審核中',
    Level: '等級',
    Rating: '評分',
    ConnectionNumber: '接單數',
    SelfIntroduction: '自我介紹',
    chat: '聊天',
    Whoops: '啊啊！',
    OK: '確認',
    Withdraw: '提領',
    Noconnection: '網路連結斷開了！請檢查一下您的網路連結～',
    tryAgain: '再試看看喔',
    Price: '價格',
    pricePer: '每半小時',
    Earnings: '收入',
    hourserved: '技能時長',
    Transactions: '交易明細',
    orderTaking: '上架技能',
    onlyWithDraw:
      'Your earnings can only ly be withdrawn after a 30-day clearance.'
  },
  record: {
    contactus: '聯絡我們',
    ResolutionCenter: '客訴中心',
    Pendingclearance: '等待清算',
    sentemail: '確保你已發送郵件',
    Clearance: '清算',
    Hi: '您好',
    Sent: '我已經發郵件了',
    example: '範例',
    morehelp: '如果需要更多的幫助，請聯絡我們的官方郵箱。我們的郵箱是：',
    Game: '技能項目',
    SendEmail: '傳送郵件',
    rejectedcancellation:
      'Since you rejected the cancellation request, please send us an Email, writing down the reason and uploading files by attachment to support your side of view. You will get our relply within 72 hours. Our Email address is',
    applyingcancel:
      'Since you are applying to cancel the order, please send us an Email, writing down the reason and uploading files by attachment to support your view. You will get our relply within 72 hours. Our Email address is',
    OrderID: '訂單ID',
    Copy: '複製',
    Totalprice: '總付款金額',
    name: '暱稱',
    Withdrawn: '提領',
    Availabletowithdraw: '可提領收入',
    amountofevery: '每次至少提領NT$3000，最高提領NT$10000',
    onlywithdrawonce: '提領後3-5個工作日到賬',
    Yourearningscan: '滿NT$3000才能提領',
    reviewthecase: '確保已經發送郵件了',
    stepinthease: '如果你已發送客訴郵件，nicee將會介入處理',
    canwithdraw:
      'Every transaction will go through a 7-day clearance before you can withdraw.'
  },

  login_title: '想玩遊戲就約我',
  login_facebook: 'Facebook 登入',
  login_line: 'LINE 登入',
  login_google: 'Google 登入',
  login_other: '其他登入方式',
  login_phone: '手機號登入',
  login_agree: '登入即代錶您同意nicee用戶協議與隱私權條款',
  login_smscode: '獲取認證碼',
  login_now: '立即登入',
  home_index: '首頁',
  home_feed: '動態',
  home_express_book: '急速約單',
  home_message: '訊息',
  home_my: '我的',
  home_recommended: '推薦',
  home_lol: '英雄聯盟',
  home_duel: '傳說對決',
  home_voice_chat: '語音交流',
  home_battle_canyon: '激鬥峽穀',
  home_pubg: '絕地求生',
  home_small_alarm: '小鬨鍾',
  home_rankings: '排行版',
  home_top_players: '每日大神匯聚',
  home_voice_room: '語音房',
  home_input_nick: '請輸入昵稱/ID/遊戲技能',
  home_cancel: '取消',
  home_skill_names: '各技能名稱',
  home_pull_more: '下拉即可召喚更多陪陪',
  home_release_more: '釋放即可召喚更多陪陪',
  home_loading: '加載中',
  gamelol: '英雄聯盟',
  gamelol_order_king: '回單王',
  gamelol_rank_up: '上分必備',
  gamelol_filter: '篩選',
  gamelol_week_star: '聯盟周星',
  gamelol_sort: '排序',
  gamelol_synthesize_sort: '綜合排序',
  gamelol_new_sort: '新人優先',
  gamelol_high_sort: '高價優先',
  gamelol_low_sort: '低價優先',
  gamelol_gender: '性別',
  gamelol_female: '女生',
  gamelol_male: '男生',
  gamelol_label: '標簽',
  gamelol_first_discount: '首單優惠',
  gamelol_buzzworthy: '夯口碑',
  gamelol_high_popular: '高人氣',
  gamelol_high_new: '小萌新',
  gamelol_7_minute: '嘗鮮',
  gamelol_expert_guiding: '大神帶飛',
  gamelol_language_support: '語言陪伴',
  gamelol_tier: '段位',
  gamelol_elite: '菁英',
  gamelol_grand_master: '宗師',
  gamelol_master: '大師',
  gamelol_diamond: '鑽石',
  gamelol_platinum: '白金',
  gamelol_expert_position: '擅長位置',
  gamelol_top_lang: '上單',
  gamelol_jungle: '打野',
  gamelol_mid_lang: '中單',
  gamelol_adc: 'ADC',
  gamelol_support: '輔助',
  gamelol_price: '價格',
  gamelol_clear_filter: '清空篩選',
  gamelol_complete: '完成',
  gameduel: '傳說對決',
  gameduel_week_star: '傳說周星',
  gameduel_tier: '段位',
  gameduel_eternal_legend: '永恆傳說',
  gameduel_battlefield_legend: '戰場傳說',
  gameduel_starlight: '星耀',
  gameduel_diamond: '鑽石',
  gameduel_platinum: '鉑金',
  gamevoice: '語音交流',
  gamevoice_week_star: '音樂周星',
  gamevoice_tier: '段位',
  gamevoice_mom_voice: '媽音',
  gamevoice_queen_mom: '禦媽音',
  gamevoice_queen_sister: '禦姐音',
  gamevoice_queen_little: '少禦音',
  gmaevoice_girl_little: '少女音',
  gmaevoice_luoli_little: '少蘿音',
  gamevoice_luoli: '蘿莉音',
  gamevoice_shou: '受音',
  gamevoice_uncle: '叔音',
  gamevoice_youth: '青年音',
  gamevoice_youth_shou: '青受音',
  gamevoice_youth_uncle: '青叔音',
  gamevoice_live: '實況主',
  gamebattle: '激鬥峽穀',
  gamebattle_week_star: '綜遊周星',
  gamebattle_tier: '段位',
  gamebattle_elite: '菁英',
  gamebattle_grand_master: '宗師',
  gamebattle_master: '大師',
  gamebattle_diamond: '鑽石',
  gamebattle_emerald: '翡翠',
  gamebattle_platinum: '白金',
  gamehero: '特戰英豪',
  gamehero_tier: '段位',
  gamehero_soul: '輻能戰魂',
  gamehero_myth: '神話',
  gamehero_diamond: '鑽石',
  gamehero_platinum: '白金',
  gamehero_gold: '金牌',
  gamehero_silver: '銀牌',
  gameapex: 'APEX',
  gameapex_tier: '段位',
  gameapex_hunter: 'APEX捕食者',
  gameapex_master: '大師',
  gameapex_diamond: '鑽石',
  gameapex_platinum: '鉑金',
  gamenaraka: '永劫無間',
  gamenaraka_tier: '段位',
  gamenaraka_abadi: '無間修羅',
  gamenaraka_bulan: '蝕月',
  gamenaraka_jatuh: '隕星',
  gamenaraka_platinum: '鉑金',
  all_skills: '全部技能',
  normalskill: '常用技能',
  mbgame: '手機遊戲',
  mbgame_duel: '傳說對決',
  mbgame_battle: '激鬥峽谷',
  mbgame_kart: '跑跑卡丁車Rush+',
  mbgame_live: '我要活下去',
  mbgame_pubg: '絕地求生M',
  mbgame_speed: '極速領域',
  mbgame_cn_pubg: '和平精英',
  mbgame_tomorrow: '明日之後',
  mbgame_knives_out: '荒野行動',
  mbgame_close_eye: '天黑請閉眼',
  mbgame_five: '第五人格',
  mbgame_auto_chess: '多多自走棋',
  mbgame_royale: '皇室戰爭',
  mbgame_bnb: '爆爆王M',
  mbgame_super_star: '明星三缺一',
  mbgame_dunk: '灌籃高手',
  mbgame_glory: '王者榮耀',
  mbgame_sky: 'sky光遇',
  mbgame_impact: '原神',
  mbgame_ro: 'RO新世代',
  mbgame_tom: '湯姆貓與傑利鼠：玩命追逐',
  mbgame_duty: '決勝時刻M',
  mbgame_palyer: '天天玩樂園',
  pcgame_lol: '英雄聯盟',
  pcgame_battle: '特戰英豪',
  pcgame_apex: 'APEX',
  pcgame_naraka: '永劫無間',
  pcgame_tft: '聯盟戰棋',
  pcgame_pubg: '絕地求生',
  pcgame_among: '太空狼人殺',
  pcgame_pubg_lite: '絕地求生Lite',
  pcgame_duty: '決勝時刻',
  pcgame_dota2: 'DOTA 2',
  pcgame_csgo: 'CSGO',
  pcgame_division2: '全境封鎖2',
  pcgame_six_siege: '彩虹六號',
  pcgame_fortite: 'Fortnite',
  pcgame_overwatch: '鬥陣特工',
  pcgame_flat: 'Human：Fall Flat',
  pcgame_world: '我的世界',
  pcgaame_monster_world: '魔物獵人：世界',
  pcgame_bnb: '爆爆王',
  pcgame_ring: '無限法則',
  pcgame_dead: '黎明死線',
  pcgame_exile: '流亡黯道',
  pcgame_war: '魔獸世界',
  pcgame_maplestory: '楓之谷',
  pcgame_rust: 'Rust',
  pcgame_monopoli: '大富翁',
  pcgame_overcooked: '煮過頭',
  pcgame_hearthstone: '爐石戰記',
  pcgame_gtav: 'GTA V',
  pcgame_warframe: 'Warframe',
  pcgame_knockout: '糖豆人',
  pcgame_super_animal: '超級動物大逃殺',
  pcgame_hunter_rise: '魔物獵人：崛起',
  pcgame_double: '雙人成行',
  pcgame_diablo4: '暗黑破壞神4',
  pcgame_animal_crossing: '動物森友會',
  gamevoice_lover: '虛擬戀人',
  gamevoice_good: '好聲音',
  gamevoice_no_sleep: '失眠陪伴',
  gamevoice_alarm: '小鬧鐘',
  gamevoice_film_online: '線上看電影',
  gamevoice_ask: '情感諮詢',
  status: '動態',
  status_newest: '最近',
  status_recommend: '推薦',
  status_track: '追蹤',
  status_just: '剛剛發佈',
  status_comment: '馬上留言，加入討論吧',
  status_like: '喜歡',
  status_push_new: '發佈動態',
  status_push: '發佈',
  status_share: '分享一下今天的心情吧',
  status_input: '點擊輸入話題（限10字）',
  status_link: '點擊設置關聯技能',
  quickorder: '急速約單',
  quickorder_progress: '進行中的約單',
  quickorder_find: '正在尋找陪玩師',
  quickorder_report: '舉報',
  quickorder_grab_time: '搶單倒計時',
  quickorder_complete: '已完成的約單',
  quickorder_record: '僅保留最近10條約單記錄',
  quickorder_want: '想找什麼樣的陪玩師呢？',
  quickorder_remark: '備註：“聲音好聽”等',
  myorder: '我要約單',
  myorder_want: '想找什麼樣的陪玩師呢？',
  myorder_lol: '英雄聯盟模式不限牌位不限',
  myorder_sex: '性別不限',
  myorder_price: '單價不限',
  myorder_count: '數量（局）',
  order_complete: '確認訂單',
  order_billing_mode: '計費模式',
  order_billing_mode_choose: '選擇計費模式',
  order_normal_mode: '標準模式',
  order_by_count: '購買數量',
  order_discount: '優惠券',
  order_none: '暫無可用',
  order_fist_discount: '首單優惠',
  order_sum: '總計',
  order_total_pay: '總付款金額',
  confirm_order_placement: '確認下單',
  message: '訊息',
  message_line: '綁定Line通知，訊息不漏接',
  message_system: '係統通知',
  message_house_keeper: '會員小管家',
  message_limit_activity: '限時活動',
  message_guard: '守護係統',
  message_none: '還没有訊息喔',
  chat_share: '分享',
  chat_block: '封鎖',
  chat_report: '檢舉',
  chat_cancel: '取消',
  chat_hi: '哈嘍你好嗎？',
  chat_hope: '現在有空嗎？（期待~',
  chat_ok: '好啊好啊！',
  chat_play: '來一場？',
  chat_next: '我們改天再約可以嗎？',
  chat_some: '說些什麼吧',
  chat_send: '發送',
  report: '舉報',
  report_reason: '選擇舉報理由',
  report_harassment: '發送虛假與有害信息騷擾用戶',
  report_fake: '虛假個人資料',
  report_violation: '利用違規手段下單或接單',
  report_no_order: '陪玩師不接單',
  report_private_order: '私單檢舉（核實有獎）',
  report_other: '其他違規行為',
  report_picture: '請上傳圖片證據',
  report_5_pic: '必填，請上傳最多5張清晰的關聯材料',
  report_push: '提交',
  profile: '我的',
  profile_nicee: '金幣',
  profile_diamond: '鑽石',
  profile_candy: '糖果',
  profile_discount: '優惠券',
  profile_history: '查看曆史訂單',
  profile_orders: '我的訂單',
  profile_gifts: '我的送禮',
  profile_see: '我看過',
  profile_fllow: '我的追蹤',
  profile_dressup: '裝扮',
  profile_invite: '邀請',
  profile_customer: '客服',
  profile_setting: '設置',
  profile_player: '我的（陪玩師面板）',
  profile_income: '收入',
  profile_exchange: '兌換/贈送',
  profile_skills: '技能',
  profile_feed: '動態',
  profile_client: '客戶',
  profile_visit: '最近來訪',
  profile_self_promotion: '自推廣',
  profile_fans: '我的粉絲',
  profile_total_rating: '綜合評分',
  profile_voice_room: '我的語音廳',
  material: '資料',
  material_edit: '編輯資料',
  material_photo: '我的相冊',
  material_more_photo: '您可以上傳9張圖片嚮我們展示更多的了解你',
  material_lan_desc: '添加語言介紹',
  material_self_dec: '添加自我介紹',
  material_sex: '性別',
  material_birthday: '生日',
  material_address: '居住地',
  material_mars: '火星',
  material_guard: '守護者',
  material_null: '虛位以待',
  material_guard_amount: '當前設定初始守護金額為750',
  material_fisrt_guard: '首屏守護專位',
  material_special: '專屬頭像框',
  material_comment: '評論區昵稱高亮',
  material_self_desc: '自我簡介',
  material_guard_amount_set: '設定初始守護金額',
  material_cancel: '取消',
  material_save: '保存',
  material_content_null: '哇嗚，這裏好空~',
  material_self_profile: '個人信息',
  material_feed: '動態',
  maerial_feed_push: '發佈動態',
  material_no_feed: '暫時還未發佈任何動態喔~',
  level_desc: '等級說明',
  level_now: '當前等級',
  level_normal: '普通會員',
  level_month: '本月還需消費1，可提升至VIP1',
  level_benefits: '等級權益',
  member_exclusive_skin: '會員專屬裝扮',
  unlock_with_1688_spending: '月消費達1688解鎖',
  exclusive_avatar_frame: '包含專屬頭像框、氣泡框、入場橫幅',
  monthly_10_coin_voucher: '每月1張10幣折價券',
  no_minimum_spending_requirement: '無消費門檻限製，每月1號發放',
  upgrade_pending: '待升級',
  diamond_member: '鑽石會員',
  sparkling_fireworks_avatar_frame: '“綺麗焰火”頭像框',
  sparkling_stars_avatar_frame: '“璀璨星辰”頭像框',
  dream_car_mount: '“夢幻跑車”坐騎',
  white_tiger_avatar_frame: '“白虎”頭像框',
  extreme_car_mount: '“極限跑車”坐騎',
  black_gold_member: '黑金會員',
  qilin_avatar_frame: '“麒麟”頭像框',
  white_tiger_mount: '“白虎”坐騎',
  crystal_shine_avatar_frame: '“晶耀”頭像框',
  qilin_mount: '“麒麟”坐騎',
  exclusive_gift_pyramid: '專屬禮物“金字塔”',
  legendary_member: '傳奇會員',
  diamond_chest_available_this_month: '當月可領取鑽石寶箱',
  current_defense_attempts: '當前擁有的保級次數',
  not_met_requirements: '未達標',
  cancel_10_quick_dates_per_month: '每月可主動取消10次急速約單',
  free_defense_privilege: '可享免費保級特權',
  specify_5_recommended_privileges: '可指定陪玩師上推薦特權5次',
  legend_avatar_frame: '“傳奇”頭像框',
  phoenix_mount: '“鳳凰”坐騎',
  exclusive_gift_sky_city: '專屬禮物“天空之城”',
  specify_1_app_cover_privilege: '可指定陪玩師上APP封面特權1次',
  king_legend_avatar_frame: '“王者傳奇”頭像框',
  dragon: '“神龍”坐騎',
  exclusive_gift_legend_throne: '專屬禮物“傳奇王座”',
  levelrule: '等級規則',
  levelrule_1: '有效期計算:從獲得等級當期起，等級身份有效期至下個月月末。',
  levelrule_2:
    '舉例：用戶在2月5日獲得等級VIP5，則VIP5過期時間為3月31日，4月1日重新結算等級。',
  levelrule_3:
    '等級升級: 用戶通過消費 (訂單，禮物消費) 可提升等級。常消費滿足升級條件時會於當日獲得新等級，新等級過期時間為升級當日至下個月末。',
  levelrule_4:
    '舉例: 用戶2月5日為VIP5，2月6日通過消費達到VIP6，則VIP6的有效期2.06-3.31。',
  levelrule_5:
    '保留等級:用戶已有某等級，過期當月消費達到當前等級要求消費金額的70%，即可保留等級。',
  levelrule_6:
    '舉例: 用戶2月5日常前等級VIP11。假定11級封消費金額點100000，有效期至3.31,則續等需要4月1日前消費達到70000元，則下個月才可以進行等級保留。',
  levelrule_7:
    '等級降級:在用戶等級過期當月，消費金額未達到對應等級的保留等級要求，則下一個結算月會降低等級，下個月没有完成當前對應等級要求的保留等級消費金額，則再降等級，以此推。',
  levelrule_8:
    '舉例: 用戶2月5日VIP5，若在結算月 (3月) 結束之前消費未達到VIP5與VIP4的要求的消費金額的70%，但達到了VIP3的要求消費金額的70%，則4月1號開始用戶降級至VIP3。',
  retention_privilege: '保級特權',
  retention_privilege_1:
    '當期未消費足夠保級金額，可以使用一次【保級特權】，繼續保留會員等級到下個月末。屆時下下月初會員等級是否保留需要根據結算月以及保級期間用戶消費情況進行結算決定是否保留等級。【保級特權】: 每連續保持該等級會員三個月，可獲得一次【保級特權】機會。',
  retention_privilege_2: '最高存有2次',
  retention_privilege_3: '不能連續兩個月使用',
  retention_privilege_4:
    '如果掉級後重新回到SVIP1、SVIP2或者上個月使用了【保級特權】，則連續保持等級月數重新計算。',
  retention_privilege_5:
    '若用戶在存有保級特權未使用的前提下晉升到更高等級的會員時保級次數會減少1次。',
  retention_privilege_6: '指定陪玩師上推薦特權',
  retention_privilege_7:
    '每月可推薦指定陪玩師上某時間段的推薦位，並配置為被推薦陪玩師配置專屬標識 (單次推薦時長為6小時)',
  retention_privilege_8: '指定陪玩師上APP封面特權',
  retention_privilege_9:
    '每月可推薦陪玩師上官方定專屬app封面1次，上推薦後所有用戶打開app均會瀏覽到您所推薦陪玩師的專屬封面。',
  recharge: '儲值',
  recharge_1: '限時活動：狂歡大派送',
  recharge_2: '儲值帳號ID',
  recharge_3: '暱稱',
  recharge_4: '選擇金額',
  recharge_5: '選擇付費方式',
  recharge_6: '信用卡（限免）',
  recharge_7: '信用卡',
  recharge_8: 'ATM轉賬',
  recharge_9: '商超代碼',
  recharge_10: 'PayPal',
  recharge_11: '確認儲值',
  discount: '優惠券',
  discount_1: '兌換優惠券',
  discount_2: '暫無優惠券',
  discount_3: '失效優惠券',
  discount_4: '確認兌換',
  discount_5: '請輸入兌換碼',
  discount_6: '點擊輸入兌換碼',
  discount_7: '立即兌換',
  myorder_1: '訂單教程',
  myorder_2: '全部訂單',
  myorder_3: '進行中的訂單',
  myorder_4: '歷史訂單',
  myorder_5: '暫無訂單',
  orderdetail: '訂單詳情',
  orderdetail_1: '訂單編號',
  orderdetail_2: '已取消',
  orderdetail_3: '總計',
  orderdetail_4: '數量',
  orderdetail_5: '下單',
  orderdetail_6: '訂單取消',
  gifts: '禮物',
  gifts_1: '收到的禮物',
  gifts_2: '您目前還沒有收到禮物，再接再厲喔~',
  gifts_3: '送出的禮物',
  gifts_4: '您目前還沒有送出禮物喔~',
  dressup_center: '頭像框',
  dressup_center_1: '氣泡框',
  dressup_center_2: '入場橫幅',
  dressup_center_3: '坐騎',
  dressup_center_4: '繁花之戀',
  dressup_center_5: '心花綻放',
  dressup_center_6: '綠色情人節活動獲得',
  dressup_center_7: '年度冠軍',
  dressup_center_8: '年度亞軍',
  dressup_center_9: '年度季軍',
  dressup_center_10: '年度八強',
  dressup_center_11: '年度老闆',
  dressup_center_12: '年度活動獲取',
  dressup_center_13: '紅茵球場',
  dressup_center_14: '藍茵戰場',
  dressup_center_15: '世界杯活動獲取',
  dressup_center_16: '下單周榜',
  dressup_center_17: '下單榜周榜冠軍獲取',
  dressup_center_18: '甜爸',
  dressup_center_19: '甜寶',
  dressup_center_20: '父親節活動獲得',
  dressup_center_21: '遇龍舟',
  dressup_center_22: '好粽意',
  dressup_center_23: '端午節活動獲得',
  dressup_center_24: '動人聲',
  dressup_center_25: '待君傾',
  dressup_center_26: '以歌聲入人心活動獲得',
  dressup_center_27: '天使寵愛',
  dressup_center_28: '水晶寵愛',
  dressup_center_29: '寵愛積分賽活動獲得',
  apply_for_settlement: '申請入駐',
  apply_for_settlement_1: 'nicee陪玩誠邀你成為我們的陪玩師',
  apply_for_settlement_2: '我們等待這樣的你',
  apply_for_settlement_3: '風趣幽默，熱愛聊天；熱愛遊戲，也熱愛交友。',
  apply_for_settlement_4: '無論出於好奇或者職業，都希望把陪玩師做好。',
  apply_for_settlement_5:
    '如果你是這樣的人，快快點擊申請入駐，開啓你的陪玩師之旅吧！',
  apply_for_settlement_6:
    '我已閱讀並同意《nicee陪玩師行為守則》《服務協議與隱私條例》',
  apply_for_settlement_7: '立即申請',
  invite: '邀請',
  invite_1: '長達66天分傭獎勵',
  invite_2: '邀請好友抽豐厚現金',
  invite_3: '分享',
  invite_4: '抽1次，剩餘0次機會',
  invite_5: '10連抽，剩餘0次機會',
  invite_6: '謝謝惠顧',
  invite_7: '我的邀請碼',
  invite_8: '點擊可複製',
  invite_9: '每邀請一個好友綁定邀請碼則可獲得1次抽獎機會',
  invite_10: '與您綁定的好友每儲值1000nicee幣可獲得1次抽獎機會',
  invite_11: '當前已纍積獲得',
  invite_12: 'nicee幣已自動充值到您的錢包（提取到您可提領收入）',
  invite_13: '我的活動記錄',
  invite_14: '暫無記錄，快去邀請好友註冊吧',
  invite_15: '綁定好友邀請碼',
  invite_16: '我是好友邀請註冊，綁定好友邀請碼幫好友獲得抽獎機會',
  niceebot: 'nicee智慧機器人',
  niceebot_1:
    '我是nicee智慧機器人，請問您需要諮詢什麼問題呢？請描述您遇到的問題~',
  niceebot_2: '您是否遇到以下問題：',
  niceebot_3: '請問我的nicee ID是？',
  niceebot_4: '如何申請入駐陪玩師呢？',
  niceebot_5: '如何申請技能？需要提供什麼材料？',
  niceebot_6: '如何製作聲音卡？',
  niceebot_7: '怎麼算完成訂單呢？',
  niceebot_8: '訂單遇到糾紛時該怎麼辦呢',
  niceebot_9: '請問可以去哪裏搶單？',
  niceebot_10: '如何儲值？',
  niceebot_11: '成功付款後30分鍾餘額没有變化，請問我該怎麼辦？',
  niceebot_12: '請問怎麼將陪玩的收益轉換成現金呢？',
  niceebot_13: '為什麼我的頭像不能通過審核？',
  niceebot_14:
    '我没有看到客服小助手的按鈕或是官方發佈的新功能，是不是係統壞了？',
  niceebot_15: '本照認證在哪申請呢？',
  niceebot_16: '請用一句話描述您的問題，盡可能簡短喔^^',
  niceebot_17: '發送',
  niceebot_18: '溫馨提示',
  niceebot_19: '您確認要結束本次對話嗎？',
  niceebot_20: '確認',
  niceebot_21: '取消',
  official_customer_app_open_failed:
    '是否已安裝 Nicee App？若尚未安裝，可前往應用商店下載。',
  official_customer_go_to_store: '前往應用商店',
  leaderboard: '榜單',
  leaderboard_1: '紅人榜',
  leaderboard_2: '新秀榜',
  leaderboard_3: '受寵榜',
  leaderboard_4: '下單榜',
  leaderboard_5: '送禮榜',
  leaderboard_6: '日榜',
  leaderboard_7: '周榜',
  leaderboard_8: '獎勵及規則',
  leaderboard_9: '魅力值',
  luck_party: '幸運糖果Party',
  luck_party_1: '抽獎狂送鑽石金幣拿會員好禮',
  luck_party_2:
    '幸運糖果會員專屬派對，抽鑽石金幣拿會員等級超多獎勵，等你來拿！',
  luck_party_3: '活動時間',
  luck_party_4: '我的糖果',
  luck_party_5: '祝你好運',
  luck_party_6: '開始抽獎',
  luck_party_7: '每次消耗200糖果或消耗500鑽',
  luck_party_8: '10大會員權益，等你來拿',
  luck_party_9: 'VIP1以上均可獲得會員專屬裝扮',
  luck_party_10: 'VIP8以上均可額外解鎖新頭像框',
  luck_party_11: 'VIP5以上可領取免費折價券',
  luck_party_12: 'VIP10以上可領取免費鑽石',
  luck_party_13: 'VIP9以上均有專屬坐騎',
  luck_party_14: '開啓特殊坐騎（夢幻跑車、極限跑車、神龍坐騎）體驗，顯尊貴身份',
  luck_party_15: 'VIP12以上均可享專屬會員禮物',
  luck_party_16: '尊享專屬禮物（天空之城、傳奇王座）體驗，點燃全場熱情',
  luck_party_17: '查看10大會員權益',
  palyer_panel_1: '收入',
  palyer_panel_2: '兌換/贈送',
  palyer_panel_3: '贈送獎1000鑽',
  palyer_panel_4: '技能',
  palyer_panel_5: '動態',
  palyer_panel_6: '客戶',
  palyer_panel_7: '最近來訪',
  palyer_panel_8: '自推廣',
  palyer_panel_10: '我的訂單',
  palyer_panel_11: '我的收禮',
  palyer_panel_12: '我的粉絲',
  palyer_panel_13: '綜合評分',
  palyer_panel_14: '0分（高過0%）',
  palyer_panel_15: '我的語音廳',
  palyer_panel_16: '邀請',
  palyer_panel_17: '客服',
  palyer_panel_18: '設置',
  palyer_panel_19: '收入明細',
  palyer_panel_20: '可提領',
  palyer_panel_21: '結算中',
  palyer_panel_22: '總收入',
  palyer_panel_23: '結算中明細',
  palyer_panel_24: '收支明細',
  palyer_panel_25: '暫時沒有產生記錄哦',
  line_1: 'LINE通知設定',
  line_2: '當有人留言，有心訂單時候，用LINE通知我',
  line_3: '請先看完下方的教學步驟，然後點擊開啓按鈕',
  line_4: '點擊下方右側的開關按鈕',
  line_5:
    '在新開網頁中登入LINE，若您已安裝LINEapp，下拉網頁會出現“在LINE中打開”，點擊即可快捷登入。',
  line_6: '登入成功後，點擊第一個選項“通過1對1聊天接收LINE Notify的通知”',
  line_7: '點擊頁面最下方的“同意並聯動”按鈕',
  line_8: '啓用LINE通知',
  skill_manage_1: '當前可接單',
  skill_manage_2: '添加新技能',
  skill_manage_3: '審核通過，請完善技能信息',
  myclient_1: '我的客戶',
  myclient_2:
    '為了方便你更好的管理客戶，我們特意為你準備了客戶管理工具，快來看看吧！',
  myclient_3: '好久不見',
  myclient_4: '此處展示7-30天給您下單的客戶，當老朋友出現時記得打個招呼喔~',
  myclient_5: '平臺新人',
  myclient_6: '暫時沒有新用戶，去維護一下老朋友吧',
  recent_visitor_1: '最近來訪',
  recent_visitor_2: '最近30天的訪客',
  recent_visitor_3: '如何獲得更多曝光',
  recent_visitor_4: '第1次訪問',
  mypic_2: '超心動',
  mypic_3: '完成身份認證，享受3大特權',
  mypic_4: '本照徽章',
  mypic_5: '獲得官方標示',
  mypic_6: '官方推薦',
  mypic_7: '提升曝光量',
  mypic_8: '訂單提升',
  mypic_9: '吸引更多用戶',
  service_1: '服務概況',
  service_2: '綜合評分',
  service_3: '近60天數據',
  service_4: '全部技能',
  service_5: '回單率',
  service_6: '低於標準',
  service_7: '您的回單率低於平臺平均水平，要努力喔~',
  service_8: '下單新用戶數',
  service_9: '二次下單用戶數',
  service_10: '人均回單金額',
  service_11: '回單金額',
  service_12: '1分鍾回複率',
  service_13:
    '可接單狀態下，您在1分鍾內回複的數據偏低，這將影響到你的曝光和接單。',
  service_14: '有效好評率',
  service_15: '帶有5字以上的五星好評數據偏低，記得請用戶留下文字評價喔！',
  service_16: '有效好評數',
  service_17: '總好評數',
  myroom: '我的房間',
  who_1: '誰看過我',
  who_2: '最近30天的訪客',
  who_3: '聊一聊',
  legal_rules_title: 'nicee陪玩師行為守則',
  legal_privacy_title: '服務協議與隱私條款',
  who_4:
    '*入駐nicee的陪玩師需為年滿十八歲及以上之完全行為能力人，已閱讀，了解並同意本服務協議之所有內容及其後之修改變更，方得使用本平臺之服務。\n為營造健康的平臺氛圍，保障用戶權益，請陪玩師遵守以下行為守則：\n壹.不得在個人信息、評論、技能描述、私信中發佈違反法律法規信息\n包括但不限於危害安全、色情低俗、暴力恐怖、賭博、危害未成年等違法內容\n貳.不得在個人信息、評論、技能描述、私信中發佈垃圾廣告信息\n包括但不限於以推廣、銷售、盈利為目的，發佈影響?戶體驗的內容\n叄.不得在個人信息、評論、技能描述、私信中發佈盜版侵權信息\n包括但不限於未經本人同意，盜用他人肖像、姓名、作品的內容\n肆.不得在個人信息、評論、技能描述、私信中發佈虛假信息\n包括但不限於詐騙，謠言等不實信息\n伍.不得在個人信息、評論、技能描述、私信中發佈廣告宣傳信息\n宣傳鼓勵使用其他競爭平臺，以任何形式包括但不限於頭像、圖片、暱稱、標題、描述、評論等方式傳播任何未經nicee平臺授權的第三方個人/平臺/廣告信息/工具\n陸.不得脫離平臺交易\n通過任何其他途徑進行非平臺訂單交易\n柒.不得騷擾辱罵他人\n包括但不限於對平臺用戶發錶謾罵，嘲諷，人身攻擊等騷擾信息\n捌.不得偽造互動數據\n包括但不限於人工或機器作弊幹預偽造數據，惡意註冊多個帳號使用等作弊行為\n玖.不得損害平臺利益，擾亂平臺秩序\n以任何形式幹擾平臺管理，嚴重擾亂平臺秩序，損害其他用戶和平臺合法權益的行為\n平臺核實與處罰說明：\n1.平臺會通過用戶反饋，平臺監控等多方面方式進行違規確認。\n2.為保障用戶權益，請陪玩師保存自己的陪玩紀錄以便核實。\n3.用戶若不遵守以上行為守則，一旦發現違規行為，平臺會視情節輕重程度採取相應的處罰措施，包括警告，限製部分功能使用權限，封禁帳號，嚴重行為將長期凍結帳號。\n本公司有權於任何時間修改或變更本陪玩師行為守則，並公告於本平臺之網站（https://nicee.tw），請您隨時註意該等修改或變更，恕不再另行個別通知。若您於任何修改或變更後繼續使用本平臺之服務，則視為您已閱讀、了解並同意接受該等修改或變更。並同意完全遵守本陪玩師行為守則。\n我們緻力於為廣大用戶營造安全健康的服務環境，平臺的發展需要您的支持與配合，如在使用過程中有任何建議和反饋，歡迎聯繫我們的客服助手，祝您在nicee玩得愉快。',
  who_5:
    '本服務協議與隱私條款（以下簡稱「本協議」）載明您與「nicee」之間的權利義務關係，為保障您（以下或稱「用戶」）的權益，請於註冊為「nicee」（以下簡稱「本平臺」）用戶前仔細閱讀本條款。1、名詞定義（1）「用戶」：是指註冊、登錄、使用本平臺任何服務的個人（2）「服務」：係指本公司於本平臺上提供用戶透過電腦、智慧型裝置或其他電子化設備分享、交流與線上遊戲有關資訊之服務，以媒合平臺用戶進行【遊戲輔導】相關即時互動。2、認知與接受條款（1）當您註冊完成或開始使用本服務時，即錶示您已閱讀、了解並同意接受本服務協議之所有內容。如您不同意本服務協議的內容，或者您所屬的國家或地域排除本服務協議內容之全部或部分時，您不應註冊、登錄本平臺之網站，並應立即停止使用本平臺相關服務。（2）本公司有權於任何時間修改或變更本服務協議之內容，並公告於本平臺之網站（https://www.nicee.tw/），請您隨時註意該等修改或變更，恕不再另行個別通知。若您於任何修改或變更後繼續使用本平臺之服務，則視為您已閱讀、了解並同意接受該等修改或變更。並同意完全遵守本協議及其他相關規範」。若您於任何修改或變更後繼續使用本平臺之服務，則視為您已閱讀、了解並同意接受該等修改或變更。並同意完全遵守本協議及其他相關規範。（3）若您並非十八歲以上之完全行為能力人，則應請您的父母或監護人閱讀、了解並同意本服務協議之所有內容及其後之修改變更，方得使用本平臺之服務。當您使用本服務時，即推定您的父母或監護人已閱讀、了解並同意接受本服務協議之所有內容及其後之修改變更。（4）為促進兒童及少年身心健全發展，並保障其相關權益，您瞭解本平臺有涉及「遊戲軟體分級管理辦法」分類標準下之「輔導十五歲級」遊戲，故選擇使用相應服務前，您應先了解各遊戲官網所標明遊戲之分級標誌及適用年齡層。一旦使用特定服務，即推定您已符合相關法令對使用該遊戲之年齡層要求。3、用戶註冊與帳號保管（1）您同意於註冊用戶時提供正確、最新的資料（詳參第六條「隱私條款」），且僅能註冊登錄一個帳號，不可重覆註冊登錄。您所登錄之資料若事後有所變更時，應隨時於線上更新。如您提供的個人資料有任何不實或誤導之嫌，本公司得隨時終止您的用戶資格及停止使用各項服務之權利。（2）您須自行選擇用戶之帳號名稱以及密碼來建立帳號。若您的帳號名稱涉嫌侵權，本公司得據此要求您更改帳號名稱或逕為刪除侵權之帳號。（3）您同意一個帳號在同一時間只能有一人使用，且不會將自身帳號、密碼轉讓、出租或出借予他人使用。（4）完成註冊後，用戶將取得一個特定之密碼及用戶帳號，而維持密碼及帳號之機密安全，是用戶之責任。任何依照規定方法輸入用戶帳號及密碼與登入資料一緻時，無論是否由本人親自輸入，本平臺將推定為用戶本人所使用，故利用該密碼及帳號所進行的一切行動，用戶本人應負完全責任。（5）若您發現自身帳號遭人非法使用或有任何異常破壞使用安全的情形時，請立即通知本公司以利停止該帳號之使用；但帳號及密碼遭盜用、不當使用或其他無法辯識是否為本人親自使用之情況時，對此所緻之損害，除證明係因可歸責於本公司之事由所緻，本公司就接獲您通知以前之帳號使用，將不負責處理。4、支付方式和購買nicee金幣（1）您可利用本平臺提供的支付方式儲值「nicee餘額」點數或購買其他服務，但瀏覽本平臺所需之各項電腦設備須自行配備，包括但不限於「網際網路連線費用」、「電話費用」等電信相關費用。（2）您明確瞭解並同意，若要在nicee服務中使用特定功能（例送禮、下單陪玩師等），您必須先透過nicee認可的購買渠道購買金幣。如有違反前述規定，本公司有權停用或者刪除您的帳號，您將無法再透過您的帳號取消您所有的資料，包括您帳號中的金幣與摺扣券。（3）您明確瞭解並同意，您購買金幣是經過思考後的購買行爲，除法律另有規定外，nicee沒有任何責任義務為您提供任何理由的退款。若您購買金幣後經應用商城取消訂單，我們會將您已使用金幣收回，而使用金幣所伴隨的各種效果（包括但不限於福利、等級、經驗值、活動展示框、排行榜）也將一同收回。（4）您理解並同意，您在nicee服務中所獲得的金幣（如：節日活動、榜單活動、相互贈禮），是無法兌換現金的。且所有使用者皆不得私下進行現金交易、買賣或出借帳號。如有違反前述規定，本公司有權停用或刪除您的帳號。您將無法再透過您的帳號使用服務。5、用戶守則與平臺使用責任（1）用戶守則：您承諾絕不為任何非法目的或以任何非法方式使用本服務，並承諾遵守中華民國相關法規及國際慣例。若係中華民國以外之用戶，並同意遵守所屬國家或地域之法令。您同意並保證不得利用本平臺之服務從事侵害他人權益或違法之行為，並遵守以下用戶守則：1. 不得公佈或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、違反公共秩序或善良風俗或其他不法之文字、圖片或任何形式的檔案；不得侵害他人名譽權、肖像權、智慧財產權、商業秘密等，例如在未取得他人同意的情況下，分享可能會透露個人資訊或私人財產的內容，或未經許可在私人場所直播；2. 不得以圖像、文字、影像及語音對未滿十八歲之人錶達「遊戲軟體分級管理辦法」分類標準下之限製級內容，包含但不限於「具體性暗示」、「血腥、殘暴或恐怖畫面」、「粗鄙或仇恨性言語」、「使用毒品之畫面或情節」、「描述搶劫、綁架、自傷、自殺等犯罪或不當行為」或「其他對未滿十八歲人之行為或心理有不良影響之虞」等內容；3. 不得刊登、傳送任何侵害他人智慧財產權（包含但不限於商標權、著作權、專利權、營業秘密等）、名譽權、隱私權或其他權益之資訊；4. 不得使用冒名、詐欺或其他虛偽不正之方式進行支付、儲值，包含但不限於付款?之信?卡為偽卡或遭盜刷之情形；5. 不得將個人帳號轉讓、出租或出借予他人使用；6. 不得於未經授權之情形下，進入本公司之用戶服務係統或網路、冒用他人之帳號；7. 不得傳輸、散佈電腦病毒或其他足以幹擾或破壞電腦係統、應用程式之資料或資訊；8. 不得從事未經本公司事前授權之商業行為或交易行為，包含但不限於「虛假交易」、「利用平臺儲值管道提出現金（如：刷卡套現）或轉帳他人」、「以平臺儲值之款項交換非本平臺之服務」等非正常使用目的之行為；9. 不得從事非法交易行為，或張貼虛假不實、引人犯罪之訊息；10. 不得販賣槍砲、刀械、毒品、禁藥、盜版軟體或其他法令所禁止販賣之物品；11. 不得對其他用戶或第三人產生睏擾、不悅或違反一般網路禮節緻生反感之行為12. 不得提供賭博資訊或以其他方式發佈引誘他人參與賭博的訊息；13. 不得幹擾或中斷提供本平臺相關服務之伺服器、連結本平臺之網路，或不遵守相關程序、政策或規則等；利用外掛程式、病毒程式、程式漏洞等其他違反公平合理之方式使用本平臺之服務；14. 其他經本公司判斷可能造成本平臺損失或承擔民事法律責任之不當使用行為，及任何涉嫌違法之行為（包含但不限於任何直接或間接之詐騙、洗錢、異常交易及犯罪行為）。（2）用戶之平臺使用責任：1. 如經本公司判斷您有違反前項各款守則或有違反之虞，本公司有權立即終止或變更您的帳號權限或採取適當法律行動，包含但不限於凍結帳號、停止提供平臺服務、退款、追償損失及拒收或保留您相關交易款項至釐清相關事證為止，並得因應有權管轄機關之裁判或命令而處置或移轉您涉及不法行為之款項，本公司就前述行為不對用戶或第三人負任何賠償責任。2. 您必須為個人帳號內之行為負責，包括您所傳送的任何文字、語音、圖像、影音等內容，並承擔因內容不當所引起之所有風險，若有任何違反法律規定之情事，包括但不限於侵害本公司或第三人之智慧財產權或其他權利、利益之行為，應自負相關法律責任。3. 如經本公司判斷您有違反前項各款守則或有違反之虞，並緻本公司受有損害、支出費用（包含但不限於行政作業成本、律師費、規費、任一儲值管道之手續費、服務費）、政府裁罰或遭到任何第三人求償，您應對本公司之前述損失負全額損害賠償責任，若您嚮本公司證實前述損失不可歸責於您，且經本公司核實無誤，則該損失由本公司與您平均分擔。4. 您通過本平臺所傳送的任何內容，均不代錶本公司之觀點或政策，本公司不會對此承擔任何責任。6、隱私條款本公司相當重視您的隱私權保護，特此嚮您說明本平臺之隱私條款，以保障您的權益，請您詳閱下列內容：（1）隱私權條款適用範圍：您使用本平臺服務時本公司所蒐集到的個人識別資料。但並不適用於本平臺以外的相關連結，也不適用於非本公司所委託或參與管理的人員。（2）個人資料的蒐集目的與類別：1. 當您造訪本平臺或使用提供之服務時，因用戶註冊而請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意或另有約定，本公司不會將個人資料用於其他用途。您可以選擇不提供前述之必要個人資料，但會造成您無法使用本平臺之服務。2. 於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、點選資料記錄、瀏覽器類型、行動裝置類型、位置資訊等，做為我們增進本平臺服務的參考依據。您可以選擇關閉伺服器之記錄功能，但可能會造成您無法使用本平臺之服務的情況。3. 上述資訊蒐集之類別，包含：C001辨識個人者、C011個人描述、C012身體描述、C013習慣、C014個性、C024其他社會關係、C035休閒活動及興趣、C038職業、C051學校紀錄、C091資料主體所取得之財貨或服務、C092資料主體提供之財貨或服務、C102約定或契約、C132未分類之資料。（3）個人資料利用之對象及方式1. 為提供精確的服務，我們會將收集的數據內容進行去識別化之統計與分析。2. 上述資訊蒐集之特定目的，包含：040行銷、063非公務機關依法定義務所進行個人資料之蒐集處理及利用、069契約、類似契約或其他法律關係管理之事務、081個人資料之合法交易業務、090消費者、客戶管理與服務、091消費者保護、098商業與技術資訊、125傳播行政與管理、135資（通）訊服務、142運動、競技活動、148網路購物及其他電子商務服務、152廣告或商業行為管理、153影視、音樂與媒體管理、157調查、統計與研究分析、181其他經營合於營業登記項目或組織章程所定之業務、182其他諮詢與顧問服務。3. 個人資料利用之對象：本公司、本公司之關係企業、本公司之合作夥伴、相關委外之協力廠商（包含但不限於提供金流服務之廠商）及政府機關。4. 您對個人資料之權利：在不違反相關法律的情況下，我們確認該個人資料為您本人所有後，您可以聯絡我們行使下列權利：（1）查詢、閱覽、補充或更正您的個人資料；（2）停止蒐集、處理或利用您的個人資料；（3）刪除您的個人資料；（4）製給您個人資料的複製本；或（5）停止寄發給您相關廣告/行銷活動。（4）個人資料利用之期間及地區：1. 我們將在上述取得您個人資料目的之存續期間內或其他法令允許之期間內，處理、利用或國際傳輸您的個人資料，若您停止使用本平臺並嚮我們終止本隱私條款之執行，本平臺將停止蒐集、處理或利用您個人資料，並進行相關檔案之刪除作業。2. 本平臺蒐集您個人資料之主機位置、相關網路伺服器主機所在地及本平臺相關服務之行銷地區。（5）資料之保護：1. 本平臺設有防火牆、防毒係統等相關的各項資訊安全設備及必要的安全防護措施與風險管理機製，您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，如有違反保密義務者，將會受到相關的法律處分。2. 如因業務需要有必要委託其他單位提供服務時，本平臺亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。3. 儘管我們盡力保護您的個人資料，然仍無法保證您的個人資料百分之百不會遭受第三人之非法攔截、傳送或盜駭。前述事故發生時，我們將及時通報您，並對此啟動相關應變措施及證據保存。（6）您同意本公司，於下列情形發生時，得與第三人公開您的個人資訊：1. 經由您書面同意。2. 法律明文規定3. 為免除您生命、身體、自由或財產上之危險。4. 與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。5. 當您在本平臺的行為，違反服務條款或可能損害或妨礙平臺其他用戶之權益或導緻任何人遭受損害時，本公司揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。6. 有利於您的權益7. 本平臺委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。8. 受司法、警察或其他有權機關基於法定程序之要求。9. 因您的行為違反法令、本條款或本公司相關規範時。（7）隱私條款之修正：1. 本平臺之隱私條款將因應需求隨時進行修正，修正後的條款將於應用內告知用戶，變更之內容遵循中華民國相關法令。如您不同意所變更之內容，得隨時選擇停止使用本平臺，如您繼續使用，即錶示您同意變更之內容。2. 如果您對本平臺的隱私條款有任何問題，或欲申請個人資料的查詢、複製、補充、更正、閱覽，或欲停止蒐集以及刪除個人資料，請聯絡本平臺之客服團隊。7、第三方網站連結與內容（1）您瞭解本平臺可能會顯示廣告影音並連結至第三方網站，或轉載已註明來源之第三方網站之政令、新聞、訊息、活動等不同內容。（2）惟第三方網站不屬本服務協議得控製及負責範圍之內，其內容之正確真偽，您宜自行判斷之，本公司對其正確真偽不負任何責任。（3）您同意本公司無須為您連結至前述第三方網站所生之任何損害，負損害賠償之責任。8、用戶行為與授權（1）您所上載、輸入或提供予本平臺之任何資料（包括您的智慧財產權），即錶示您已同意授權本公司可以基於行銷目的、統計、業務改良、推廣本服務之目的，進行使用、修改、發行、散佈、重製或公開展示該等資料，並得在此範圍內將前述權利轉授權他人。（2）您並保證本平臺於服務中使用、修改、發行、散佈、重製、公開展示或轉授權該資料，不緻侵害任何第三人之相關權利，否則應對本公司之損害負賠償責任。9、智慧財產權（1）除本平臺中涉及的「遊戲」之智慧財產權由原遊戲公司享有，及第三方投放廣告所涉之智慧財產權由該廣告商享有外，本平臺所使用之程式、軟體及網站內容，包括但不限於：資訊、資料、圖片、畫面安排、服務名稱、網站架構、網頁設計及用戶內容等，包括但不限於專利權、著作權、商標權、營業秘密等智慧財產權，均為本公司所有。任何人不得逕自修改、重製、散佈、發行、公開發錶、進行還原工程或反嚮組譯。若您欲引用或轉載前述資料，均須事前取得本公司之書面同意。（2）本平臺在相關服務中所使用之圖形、文字或其組成，以及其他「nicee」標誌及產品、服務名稱（統稱「nicee之標識」），其著作權或商標權歸本公司所有，未經本公司事前書面同意，任何人不得以任何方式使用「nicee之標識」。10、服務之中斷或故障（1）本平臺所提供之服務可能會出現中斷或故障等現象，或許將造成您使用上的不便、資料喪失、錯誤等情形。您於使用本服務時宜自行採取防護措施。（2）本會對於您因使用（或無法使用）本服務而造成的損害，不負任何賠償責任。於發生下列情形之一時，本公司有權停止或中斷提供服務。因此而產生之睏擾、不便或損害，本公司對任何會員或第三人均不負任何責任：1. 對本平臺之相關軟硬體設備與電子通信設備進行必要之保養及施工時。2. 發生突發性之軟硬體設備與電子通信設備故障時。3. 在緊急情況下為維護其他會員或第三人之財產及人身安全時。4. 任何因第三人可能通過本平臺及其服務傳輸的任何軟體錯誤、病毒、木馬或類似性質的程式而緻本公司之平臺無法提供全部或一部服務時。5. 因天災等不可抗力之因素緻使本公司無法提供本平臺相關服務時。11、免責聲明（1）您明確瞭解本公司按照現有技術和條件所能達到的現狀提供本平臺之相關服務，惟無法隨時預見法律、技術以及其他風險。若出現前述風險時，本公司將努力在第一時間及時修復，但因此對於本平臺及其服務所生之任何資料的錯誤、遲延或遺漏，本公司均不負擔任何法律責任。（2）本公司對本平臺之各項服務不提供任何明示或默示之擔保，並保留因業務發展而得單方調整服務內容之權限，用戶因服務內容調整所生之損失，本公司均不負擔任何法律責任。（3）此外，您因違反本協議所生之任何損害及損失，均由您自負其責，本公司、不負擔任何損害賠償責任。12、通知：（1）您同意本公司得於任何時間點，不經通知隨時修改、暫時或永久停止繼續提供本服務（或其任一部分）的權利。（2）本平臺之通知方式包括但不限於：張貼於本服務網頁、電子郵件，或其他現在或未來合理之方式通知您，包括本服務協議之變更。但若您違反本服務協議，以未經授權的方式存取本服務，或於註冊時所提供之資料不正確或未更新，您將不會收到前述通知（3）您同意當您於本平臺登錄帳號並使用相關服務時，本平臺所為之任何及所有給您的通知均視為送達。13、其他：（1）本服務協議之解釋與適用，以及與本服務協議有關之爭議或糾紛，應依照中華民國法律予以處理，並以臺灣臺北地方法院為第一審管轄法院。（2）本協議部分無效時，不影響其他協議之效力。（3）本協議之標題僅供方便而設，不具任何法律或契約效果。',
  language_cn: '簡體中文',
  language_cn_2: '繁體中文',
  language_en: '英文',
  language_jap: '日語',
  language_idn: '印尼語',
  language_th: '泰語',
  language_vn: '越南語',
  first_recharge_bonus: '首充優惠（限時）',
  new_user_special_offer: '新人特惠',
  pull_down_more: '下拉即召喚更多陪陪...',
  release_more: '釋放即召喚更多陪陪',
  request_timeout: '請求超時',
  voice_room_update_tip: '為了正常使用語音房功能，請先升級到最新版本',
  voice_room_disabled_in_tip: '您已被管理員加入小黑屋，無法進入',
  push: '推',
  coins: '幣',
  new_user_coupon_validity: '新人無門檻優惠券有效期',
  share_to: '分享到',
  account_belongs_nicee: '該帳號為nicee官方所有',
  fans: '粉絲',
  limited_time1: '限時1幣',
  first_order_info: '平臺首單，享銅闆價',
  new_user: '新人',
  discount_price: '折',
  new_user_coupon_discount: '新人優惠券減',
  hesitant_try_a_7_minute_voice_chat_experience: '猶豫不定? 7分鐘語聊嚐鮮體驗',
  this_user_account_has_been_deleted: '該用戶帳戶已刪除',
  post_a_dynamic: '發佈動態',
  skill_information: '技能資訊',
  profile_info: '個人簡介',
  nickname: '暱稱',
  copy: '複製',
  age: '年齡',
  gift_wall: '禮物牆',
  verification_level: '認證等級',
  no_ratings_yet: '暫無評價',
  user_repurchase: '用戶復購',
  online_response_time: '在線秒回率',
  service_count: '服務人數',
  gift_ranking: '禮物榜',
  connect: '連接',
  unblock: '解除封鎖',
  she: '她',
  he: '他',
  you_have_taken_this_skill_offline_quickly_go_to_skill_management_to_put_it_online:
    '您將此技能下架了喔，趕快去技能管理上架吧～',
  this_booster_has_taken_this_skill_offline_quickly_contact_them_to_put_it_online:
    '該陪玩師將此技能下架了喔，快聯絡{msg}上架此技能吧！',
  user_not_found: '查詢不到此用戶',
  wow_its_so_empty_here: '哇嗚，這裡好空',
  no_orders_yet: '還沒有人下過單喔',
  no_gifts_received_yet: '還沒有人送過禮物喔',
  be_the_first_one_to_place_an_order_for_xxx: '成為第一個下單守護{msg}的人',
  be_the_first_one_to_send_xxx_a_gift: '成為第一個送{msg}禮物的人',
  file_generation_in_progress: '檔案生成中',
  come_to_nicee_and_find_xxx_to_play_games: '來nicee，找xxx玩遊戲',
  your_understanding_teammates_are_here: '懂你的隊友都在這',
  invite_you_to_play: '{msg}邀請你來玩{msg2}',
  great_teammates_to_play_games_with_you: 'nicee，好隊友陪你打遊戲',
  are_you_sure_you_want_to_unfollow: '確認要取消追蹤',
  think_again: '再想想',
  unfollow: '取消追蹤',
  just_online: '剛剛在線',
  online: '在線',
  you_have_blocked_the_other_party_please_unblock_and_try_again:
    '您已封鎖對方，請解封後再試',
  the_current_version_does_not_support_this_feature_please_update_the_app_version_and_try_again:
    '您當前的版本不支持此功能，請更新app版本後使用',
  id_copied_successfully: '已複製ID',
  film: '場',
  switching: '切換中...',
  release_to_switch_to_the_gaming_companion_panel: '釋放切換到陪玩師面板',
  release_to_switch_to_the_user_panel: '釋放切換到用戶面板',
  copied_uuid: '已複製uuid',
  obtain_limited_avatar_frames_and_cash: '拿限定頭像框和現金',
  language_settings: '語言設置',
  order_records: '接單記錄',
  skill_management: '技能管理',
  my_earnings: '我的收入',
  'self-promotion_settings': '自推廣設置',
  view_detailed_data: '查看詳細數據',
  to_be_improved: '有待提升',
  good: '良好',
  excellent: '優異',
  all_data: '全部數據',
  explanation_response_rate1:
    '您的服務質量越高，二次下單的新用戶越多，回單率就會提高喔～',
  explanation_response_rate3: '您的回單率還有提升空間，請繼續加油提升喔～',
  explanation_response_rate4: '您的服務錶現良好，請繼續加油喔！',
  explanation_response_rate5: '您的服務錶現優異，請繼續保持喔！',
  explanation_response_rate6: '近期沒有收到訂單，要加油喔～',
  explanation_response_rate7:
    '您的服務質量越高，回單用戶下單金額越多，數據就會提高喔～',
  explanation_response_rate8: '您的數據低於平臺平均水平，要努力喔～',
  explanation_response_rate9: '您的數據還有提升空間，請繼續加油提升喔～',
  explanation_response_rate10: '您的服務錶現良好，請繼續加油喔！！',
  explanation_response_rate11: '您的服務錶現優異，請繼續保持喔！',
  explanation_response_rate12: '近期沒有回單～',
  explanation_response_rate13:
    '您在被用戶私訊的1分鐘內積極回覆可以有效提升這個指標喔！',
  explanation_response_rate14:
    '可接單狀態下，您在1分鐘內回復的數據偏低，這將影響到你的曝光和接單。',
  explanation_response_rate15: '可接單狀態下，您的及時回復及時，繼續加油喔！',
  explanation_response_rate16: '可接單狀態下，您的及時回復超及時，繼續保持喔！',
  explanation_response_rate17: '近期未發起或收到任何會話喔～',
  explanation_response_rate18:
    '積極獲取5個字以上的五星評價可以快速提高有效好評率呦！',
  explanation_response_rate19: '用戶時常給你留言好評，繼續加油喔！',
  explanation_response_rate20: '您的服務好評如潮，繼續保持喔！',
  explanation_response_rate21: '近期未收到任何評價喔～',
  explanation_response_rate22:
    '由於您未及時回覆用戶消息或未及時接單，被係統關閉可接單狀態，5分鐘內不可開啟，請稍候嘗試',
  current_value: '當前值',
  current_index: '當前索引',
  certificate_of_this_photo1:
    '請註意，該本照認證僅針對用戶照片是否為真人做認證，仍有存在頭貼與用戶不相符的可能性',
  certificate_of_this_photo2: '照片僅限nicee社交使用，不供其他用途使用',
  certificate_of_this_photo3: '更換頭貼會導緻認證失效，需要用戶重新認證。',
  certificate_of_this_photo4: '每週可認證3次，每週一重置申請次數',
  certificate_of_this_photo5: '您已通過本照認證',
  certificate_of_this_photo6: '正在享受特權',
  certificate_of_this_photo7: '已通過本照認證',
  certificate_of_this_photo8: '頭貼確認為本人喔',
  verify_now: '立即認證',
  under_review: '審核中',
  certificate_of_this_photo9: '預計10分鐘內公佈認證結果',
  failed_photo_verification: '尚未通過本照驗證',
  certificate_of_this_photo10: '本週已達到次數上限，下週一才能再次申請驗證',
  photo_verification_rules: '本照認證規則',
  rules_for_accepting_orders1: '當前可接單規則及說明',
  rules_for_accepting_orders2: '開啟此按鈕即表示您當前可以接單',
  rules_for_accepting_orders3:
    '如果打開【當前可接單】按鈕，表示您現在可以接單，若您有以下行為，系統將自動關閉可接單狀態',
  rules_for_accepting_orders4:
    '他人當日首次向您發送訊息，您1分鐘內未及時回覆相關訊息',
  rules_for_accepting_orders5:
    '小叮嚀：如果遇到有違規行為的用戶，請直接封鎖或檢舉對方，封鎖用戶後該條消息不會影響在線狀態～',
  rules_for_accepting_orders6: '超過10分鐘未接單',
  rules_for_accepting_orders7:
    '小叮嚀：讓用戶等待太久，可不是一個好的約玩體驗喔～',
  rules_for_accepting_orders8:
    '請注意：若您被系統關閉可接單狀態，則有一段時間不可開啟接單狀態，請謹慎對待～',
  skill_add1: '還沒有添加常用技能喔',
  skill_add2: '去添加',
  skill_add3: '最多添加30個常用品類',
  skill_add4: '已添加為常用技能',
  skill_add5: '電腦遊戲',
  skill_add6: '主機遊戲',
  skill_add7: '語音陪伴',
  skill_add8: '更多技能',
  home_ranking1: '·根據當日陪玩師纍積完成訂單金額進行排名',
  home_ranking2: '·每日0:00:00清零重新計算',
  home_ranking3: '·每日0:05:00榜單更新數據',
  home_ranking4: '·專屬稱號*1天',
  home_ranking5: '·根據當周陪玩師纍積完成訂單金額進行排名',
  home_ranking6: '·週日0:00:00清零重新計算',
  home_ranking7: '·週一23：59:59榜單展示更新數據',
  home_ranking8: '·專屬稱號*1週',
  home_ranking9: '·單技能列錶置頂1天。每週二客服將詢問陪玩師置頂意嚮。',
  home_ranking10: '·根據當日新人陪玩師纍積完成訂單金額進行排名',
  home_ranking11: '·新人陪玩師定義：截至當日0:00:00，30日內入駐的陪玩師',
  home_ranking12: '·根據當周新人陪玩師纍積完成訂單金額進行排名',
  home_ranking13: '·新人陪玩師定義：截至當周週一0:00:00，30日內入駐的陪玩師',
  home_ranking14: '·單技能列錶置頂2h*3天',
  home_ranking15: '·根據當日陪玩師纍積收禮金額進行排名',
  home_ranking16: '·根據當周陪玩師纍積收禮金額進行排名',
  home_ranking17: '·根據當日平臺用戶積纍訂單總金額進行排名',
  home_ranking18: '·根據當周平臺用戶積纍確認完成訂單總金額進行排名',
  home_ranking19: '·專屬頭像框*1周',
  home_ranking20: '·根據當日平臺用戶積纍送禮訂單總金額進行排名',
  home_ranking21: '·根據當周平臺用戶積纍送禮訂單總金額進行排名',
  home_ranking22: '·專屬氣泡框*1周',
  no_one_here_at_the_moment: '這裡暫時還沒有人喔～',
  ranking_list_submit: '送出',
  contribution_points: '貢獻值',
  data_updated_every_monday_night_at_2400: '每週一晚24時更新數據',
  ranking_list_my: '我',
  congratulations_you_are_currently_ranked_first: '恭喜您目前排位第一',
  no_gifts_sent_yet: '還沒有送出禮物',
  still_need_msg_to_catch_up_with_the_previous_rank: '距離上一名還差',
  send_a_gift: '送禮',
  overall_leaderboard: '總榜',
  network_anomaly: '網絡異常',
  please_enter_a_nickname_ID_game_skill: '請輸入暱稱/ID/遊戲技能',
  clear_search_history: '清空搜索紀錄',
  related_skills: '相關技能',
  freelance_skills_marketplace: '自由技能市集',
  related_users: '相關用戶',
  sorry_no_content_related_to_msg_found: '抱歉，没有找到與{msg}相關的內容',
  pull_down_to_summon_more_updates: '下拉即召喚更多動態...',
  release_to_summon_more_updates: '釋放即召喚更多動態...',
  dynamic_deleted_successfully: '動態刪除成功',
  coins_game: '幣/局',
  people_like_this: '{msg}人喜歡',
  reply_msg: '回覆',
  write_a_message: '寫下留言',
  maximum_200_characters_allowed: '最多輸入200字喔！',
  reply: '回覆',
  delete: '刪除',
  expand_reply: '展開回覆',
  collapse_reply: '收起',
  wow_its_empty_here: '哇～空空如也',
  follow_a_boosting_specialist_to_see_their_updates: '追蹤陪玩師看動態吧！',
  express_matchmaking: '極速約單',
  find_boss: '發現老闆',
  cancel_order: '取消約單',
  what_is_the_reason_for_canceling_your_order: '您取消約單的原因是什麼呢？',
  canceling_multiple_times_will_affect_future_orders:
    '多次取消會影響以後的約單喔。',
  please_enter_the_reason: '請輸入原因...',
  experimental_operation: '嘗試性操作',
  too_few_available_game_coaches: '搶單陪玩師太少',
  unable_to_find_a_satisfactory_game_coach: '找不到滿意的陪玩師',
  incorrect_order_details: '訂單內容填寫錯誤',
  other_reasons: '其他原因',
  this_order_has_been_canceled: '已取消本次訂單',
  completed_tutorial: '已完成的教學',
  order_completed: '完成',
  order_conditions: '約單條件',
  successfully_matched_with_a_game_coach: '成功匹配陪玩師',
  a_total_of: '共',
  game_coaches_are_available_for_order: '位陪玩師搶單',
  accepted_msg_times: '接單{msg}次',
  msg_repurchase_rate: '{msg}%復購',
  express_tutorial: '極速教學',
  place_an_order: '我要約單',
  notification_settings: '通知設置',
  only_retain_the_latest_10_order_records: '僅保留最近10條約單紀錄',
  you_already_have_an_ongoing_order: '您已經有正在進行中的訂單了喔',
  guaranteed_rank_boost: '排位保贏',
  experience_order: '體驗單',
  'one-click_order': '一鍵搶單',
  'text-based_order': '文字搶單',
  'voice-based_order_only': '僅限語音搶單',
  'voice-based_order': '語音搶單',
  'one-click_order_use_voice_commands_to_place_an_order':
    '一鍵搶單：將已有技能語音發出搶單。',
  already_claimed: '已搶',
  providing_detailed_introductions_increases_the_chances_of_getting_orders:
    '豐富的介紹更容易搶到單喔',
  order_card_info1:
    '例如：“哈囉我人皮話多，最擅長的角色是珍娜，可以當你專屬sup”(5～40個字）',
  order_card_info2: '提示：嚴禁約色，違規者嚴重懲罰',
  confirm_order_claim: '確定搶單',
  no_restrictions: '不限',
  today: '今天',
  msg_month_msg2_day: '{msg}月{msg2}日',
  explanation_of_guaranteed_ein_order: '“保贏”單說明',
  order_card_info3:
    '1. 陪玩師需要自備對應段位可接單遊戲帳號\\n\\n2. 保贏訂單按勝場計價，價格可根據段位訂製，搶單時請報價\\n\\n3. 陪玩師點擊同意代錶會與用戶達成共識，獲得相互協商的淨勝場次',
  agree: '同意',
  order_card_info4: '您的英雄聯盟認證等級不符合要求，請提升等級後再搶單',
  an_error_occurred_please_refresh_the_page_and_try_again:
    '發生了一些錯誤，請刷新頁面重試',
  the_order_claim_mode_is_not_suitable: '搶單模式不符合要求',
  order_card_info5: '當前未設置“{msg}”模式的金額，請設置後再來搶單',
  go_to_settings: '去設置',
  no_mode_restrictions: '不限模式',
  the_order_pricing_unit_does_not_meet_the_requirements:
    '搶單計價單位不符合要求',
  order_card_info6: '當前未設置“{msg}”計價單位的金額，請設置後再來搶單',
  your_price_exceeds_the_order_requirements: '您的價格超過訂單要求',
  order_card_info7:
    '您的價格過高，是否為此次搶單降價？我們會為您把此次搶單的價格降到{msg}，不影響正常接單價格',
  lower_price_and_claim_order: '降價搶單',
  cancel_order_claim: '取消搶單',
  order_card_info8: '設定喚醒時間為{msg}，請確認是否同意搶單？',
  confirm: '確定',
  if_you_reach_the_elite_rank: '若您達到菁英',
  if_you_reach_the_eternal_legend_rank: '若您達到永恆傳說段位',
  order_card_info9:
    '目前保贏單實行邀請製，{msg}，請準備好相關證明，聯繫客服小助手進行申請。',
  order_card_info10: '您的段位未到達“菁英”/“永恆傳說”，請認證後再來接單',
  order_card_info11: '重複文字太多，豐富的文字介紹可以增加被選中機會喔',
  order_card_info12: '恭喜加入搶單隊列！綜合評分UP！！',
  i_want_to_schedule_an_order: '我要約單',
  'limited-time_offer_for_first-time_customers': '新人首單限時優惠！',
  remaining: '剩餘',
  what_kind_of_msg_are_you_looking_for: '想找什麼樣的{msg}呢？',
  coach: '教練',
  order_scheduling_available_from: '約單開放時間',
  early_morning: '淩晨',
  looking_for_coaching: '尋找教學',
  please_select_your_coaching_requirements: '請選擇您的教學需求',
  please_select_coaching_mode: '請選擇教學模式',
  mode: '模式',
  your_rank: '您的牌位',
  rank: '牌位',
  please_select_your_current_rank: '請選擇您目前段位',
  time: '時間',
  select_time: '選擇時間',
  select_msg: '選擇{msg}',
  voice_recording_is_required_when_securing_an_order: '陪玩師搶單時需錄製語音',
  order_card_info13:
    '可以輸入您的客製化需求，發佈色情，謾罵，廣告等內容將面臨封禁處罰',
  please_confirm_your_order_requirements: '請確認您的約單要求',
  confirm_order: '確認約單',
  order_card_info14: '選人時間為15分鐘，超時取消可能會扣除$5-$10補償陪玩師哦',
  days: '天',
  coaching_tier: '教學檔位',
  price: '單價',
  mode_unlimited: '模式不限',
  rank_no_restriction: '牌位不限',
  order_card_info15:
    '為了保證您的下單體驗，請確保帳戶餘額充足再約單喔～當前餘額：',
  insufficient_balance: '餘額不足',
  got_it: '我知道了',
  please_select_the_number_of_orders: '請選擇約單數量',
  order_card_info16: '伺服器有點不聽話，工程師正在努力馴服中',
  please_select_your_rank: '請選擇您的牌位',
  elite: '菁英',
  order_card_info17:
    '1. “保贏”約單將推送給全平臺“{msg}”教練\\n\\n2. 價格按勝場計價，具體價格與段位相關，請與陪玩師商定\\n\\n3. 陪玩師性別暫不支持選擇',
  guaranteed_win_order_explanation: '“保贏”單說明',
  insufficient_account_balance: '帳戶餘額不足',
  i_want_to_recharge: '我要儲值',
  current_balance: '當前餘額',
  order_notification_settings: '搶單通知設置',
  order_notification: '搶單通知',
  select_coach: '選擇教練',
  select_booster: '選擇陪玩師',
  countdown: '倒計時',
  my_orders: '我的約單',
  order_requirements: '約單要求',
  the_booster_is_on_the_way_please_wait: '陪玩師正在趕來，請稍後...',
  the_booster_is_on_the_way: '陪玩師正在趕來...',
  see_more: '看更多',
  randomly_select_one: '隨機選1個',
  the_maximum_number_of_boosters_available_for_order_has_been_reached_msg:
    '可參與搶單的陪玩師人數已達上限 ({msg} 位)',
  more_boosters_are_on_their_way: '更多陪玩師正在趕來...',
  no_more_available: '沒有更多了',
  buy_msg_get_msg_for_free: '滿{msg}贈{msg2}',
  apply_for_coaching: '申請教學',
  waiting_order_tip1: '您的訂單因超時自動取消',
  waiting_order_tip2: '每日取消次數超過{msg}次，當日將無法再次進行極速約單喔',
  waiting_order_tip3: '該訂單已結束',
  waiting_order_tip4: '本次搶單因超時自動取消',
  waiting_order_tip5: '還剩30秒，抓緊時間選擇喔',
  hint: '提示',
  comment: '評論',
  skill_category: '技能類別',
  tags: '標籤',
  no_suitable_game_coaches_for_now: '暫無符合條件的陪玩師喔',
  online_priority: '在線優先',
  order_quantity_priority: '單量優先',
  low_price_priority: '低價優先',
  newcomer_priority: '新人優先',
  female_only: '只看女',
  male_only: '只看男',
  essential_for_ranking_up: '上分必備',
  profile_verification: '本照',
  view_more: '查看更多',
  accept_orders: '可接單',
  times: '次',
  'in-game_currency': '幣內',
  order_completion_king: '回單王',
  hours_ago: '小時前',
  minutes_ago: '分鐘前',
  celebration: '盛典',
  korean_server_elite: '韓服精英',
  '30_minutes': '半小時',
  hour: '小時',
  round: '局',
  victory: '勝場',
  day: '天',
  '7_minutes': '七分鐘',
  within: '{msg}以內',
  verified: '已認證',
  msg_points_higher_than_msg2: '{msg}分（高過{msg2}%',
  limited_time_event_summer_carnival_giveaway: '限時活動：狂歡大派送',
  top_up_amount: '儲值金額',
  gift_msg_coins: '送{msg}? 幣',
  recharge_page_tip1:
    '您當前帳號的信用異常，暫停下單/儲值功能。如有疑問，請聯繫客服"nicee小管家"諮詢',
  contact_immediately: '馬上聯係',
  your_version_is_too_old_please_upgrade_to_the_latest_version:
    '您的版本太舊啦，請先升級到最新版本',
  summer_carnival_giveaway: '狂歡大派送',
  top_up_nicee_coins: '充值nicee幣',
  current_diamonds: '當前鑽石',
  exchange_diamonds_with_gold_coins: '用金幣兌換鑽石',
  exchange_rate: '兌換比例',
  gold_coins_exchange_115: '金幣兌換1:15',
  purchase_diamonds: '購買鑽石',
  exchanging: '兌換中...',
  exchange_successful: '兌換成功',
  exchange_failed: '兌換失敗',
  gift_msg_diamonds: '送{msg}鑽',
  credit_card: '信用卡',
  visamastercardunionpayamex: '(Visa/MasterCard/AmEx/銀聯)',
  more: '更多',
  email_address: '電子信箱',
  recharge_page_tip2: '填寫電子信箱用以收取支付通知信與電子發票。',
  please_provide_the_payers_email_address: '請填寫付款人電子郵箱',
  balance_of_heart: '心約餘額',
  recharge_page_tip3:
    '您當前帳號的信用異常，暫停下單/儲值功能。如有疑問，請搜索添加"nicee小管家"諮詢',
  recharge_page_tip4: '您的帳戶由於觸發平臺風控，暫時無法儲值和下單',
  system_abnormality: '係統異常',
  please_enter_your_email_address: '請輸入您的電子郵箱',
  incorrect_email_format: '電子郵箱格式不正確',
  purchase_successful: '購買成功',
  purchase_failed: '購買失敗',
  paypal_payment_failed: 'paypal支付失敗',
  paypal_payment_canceled: '已取消paypal支付',
  please_select_the_quantity_of_diamonds_to_purchase: '請選擇購買的鑽石數量',
  failed_to_create_order: '創建訂單失敗',
  failed_to_create_paypal_order: 'paypal創建訂單失敗',
  payment_successful: '支付成功',
  failed_to_obtain_paypal_authorization: 'paypal獲取授權失敗',
  due_to_triggering_platform_risk_control_your_account_is_temporarily_unable_to_top_up_and_place_orders:
    '您的帳戶由於觸發平臺風控，暫時無法儲值和下單',
  please_select_a_payment_method: '選擇付費方式',
  currently_you_have_msg_candies: '當前你有糖果',
  candy_tip: '糖果可參加抽獎活動，活動不定期舉辦敬請關注噢！',
  ongoing_activities: '正在進行的活動',
  past_activities: '歷史活動',
  available_coupons: '可用優惠券',
  pieces: '張',
  free_order: '免單',
  available_on_orders_over_msg: '滿{msg}可用',
  spend_msg_to_get_a_msg2_discount: '滿{msg}減{msg2}',
  valid: '有效',
  occupied: '佔用中',
  used: '已使用',
  expired: '已過期',
  deleted: '已刪除',
  cancel_use: '取消使用',
  use_now: '立即使用',
  valid_until: '有效期',
  coupons_bar_tip: '平臺好看又厲害的陪玩師那麼多，你偏偏對TA動了心 ?_？',
  exclusive_coupon: '專屬優惠券',
  can_only_be_used_for_the_referrer: '只可以對邀請人使用',
  how_to_get_more_orders: '怎樣獲得更多訂單',
  pull_down_to_refresh: '下拉即可刷新',
  release_to_refresh: '釋放即可刷新',
  coupons_bar_tip2: '恭喜您抽中【愛意驚喜紅包】',
  coupons_bar_tip3: '確認完成訂單嗎？',
  coupons_bar_tip4:
    '確認完成後，錢款將打入陪玩師帳戶，您無法再發起退款等售後申請，請謹慎操作。',
  already_completed: '已完成',
  failed_to_open_red_envelope: '開紅包失敗',
  coupons_bar_tip5:
    '為避免糾紛產生，請保證訂單已經全部完成再確認喔！確認完成後若用戶沒確認，訂單將在3天內自動完成。完成後訂單不可再進行取消或退款操作',
  thats_all_for_now: '到這裡就沒有了囉～',
  i_havent_checked_other_game_companions_yet: '暫未查看過其他陪玩師',
  coupon: '券',
  visit_msg_times: '第{msg}次訪問',
  msg_days_ago: '{msg}天前',
  invite_new_users_to_win_exclusive_prizes: '邀新爽拿限定大獎',
  the_link_has_been_copied: '已複製分享鏈接',
  invite_and_win: '邀新爽拿',
  exclusive_prize: '限定大獎',
  starting_from_msg_year_msg2_month_msg3: '{msg} 年{msg2}月{msg3}日起',
  draw_once: '抽1次',
  msg_chances_remaining: '剩餘{msg} 次機會',
  '10_draws_in_a_row': '10連抽',
  the_invitation_code_has_been_copied: '已複製邀請碼',
  invite_new_users_to_get_a_limited_edition_avatar_frame_and_cash:
    '邀請新用戶拿「限定版」頭像框和現金！',
  invite_3_people_to_register_and_get_cyberpunk_2077_3_days:
    '1、邀請註冊3人獲得電馭叛客(3天)',
  invite_30_people_to_register_and_get_cyberpunk_2077_30_days:
    '2、邀請註冊30人獲得電馭叛客(30天)',
  apullc_tip:
    '被邀請用戶90天內儲值每滿100幣，獲得1次抽獎，可抽取電馭叛客(永久)和超多現金。',
  preview_avatar_frame: '預覽頭像框',
  apullc_tip2:
    '注：陪玩師返現發放到收入，用戶返現發放到錢包。抽獎機會和獎品發放可能有一定延時，請耐心等待。使用相同手機或其他方式，一人註冊多個帳號邀請無效。',
  special_support_program_for_streamers: '實況主特別支持計劃',
  apullc_tip3:
    'Twitch，YouTube實況主如在頻道貼入邀請碼，可額外獲得唯一「英文ID」資格！如參與該計劃，請與客服聯絡。',
  i_have_accumulated_cash_rewards: '我已累計獲得現金獎勵',
  msg_draws_msg2_times_msg3_obtained: '{msg}? 抽獎{msg2}次獲得{msg3}',
  msg_friends_registered: '{msg}? 好友{msg2}註冊',
  msg_friends_bound_to_this_account_have_topped_up: '{msg}? 所綁定的好友儲值',
  i_am_registered_through_a_friends_invitation: '我是好友邀請註冊',
  bind_friend_invitation_code: '綁定好友邀請碼',
  help_friends_get_drawing_chances: '幫好友獲得抽獎機會',
  friend_invitation_code_has_been_bound: '已綁定好友邀請碼',
  enter_friend_invitation_code: '好友邀請碼填寫',
  please_enter_friend_invitation_code: '請輸入好友邀請碼',
  msg_coins: '{msg}幣',
  failed_to_draw: '抽獎失敗',
  congratulations_on_winning: '恭喜你抽中了',
  apullc_tip4: '填寫邀請碼前需要綁定當前帳號的手機號碼',
  apullc_tip5: '恭喜綁定好友邀請碼成功',
  you_are_not_a_new_user: '您並非新用戶',
  close: '關閉',
  you_have_already_bound: '您已綁定過',
  settlement_details: '結算中明細',
  including_repurchase_subsidy: '含回購補貼',
  exchange: '兌換',
  gift: '贈送',
  exchangeable_amount: '兌換金額',
  transfer_balance_tip:
    '將收入1:1兌換成nicee幣，即時到賬，可到錢包中查看(注意，此操作無法把nicee幣轉回收入)。',
  transfer_balance_tip2: '暑期活動限時開啟！6月21日-7月19日，兌換nicee幣可獲得',
  additional_10_bonus: '額外10%贈送',
  enter_amount: '輸入金額',
  please_enter_the_amount: '請輸入金額',
  exceeded_the_exchangeable_amount: '已超過可兌換金額',
  the_amount_cannot_be_0: '金額不能為0',
  transferring: '轉入中',
  confirm_exchange_of_msg_coins: '確認兌換',
  arrange: '整理',
  hold_and_drag_to_rearrange: '按住並拖動，即可重新排序',
  saved_successfully: '保存成功',
  skill_list_tip:
    '由於您未及時回覆用戶消息或未及時接單，被係統關閉可接單狀態，5分鐘內不可開啟，請稍候嘗試',
  public: '公開',
  hide: '隱藏',
  audit_not_passed_go_to_modify: '審核未通過，去修改',
  skill_cancelled_not_applied: '未申請認證，去修改',
  audit_passed: '審核通過',
  please_complete_the_skill_information: '請完善技能信息',
  go_to_modify: '去修改',
  skill_card_tip: '為了正常使用技能設置功能，請先升級到最新版本',
  skill_card_tip2: '刪除技能後將不再保存填寫的信息，確定刪除該技能嗎？',
  confirm_deletion: '確定刪除',
  deletion_successful: '刪除成功',
  deletion_failed: '刪除失敗',
  skill_card_tip3: '您的帳戶存在違規行為，已暫停技能上架，詳情請諮詢管理員',
  click_more_to_greet_with_one_click: '點擊更多還能一鍵打招呼喔～',
  all: '全部',
  chat_with_msg: '找{msg}聊天',
  new_to_the_platform: '平臺新人',
  placed_an_order_msg_days_ago: '{msg}天前下單',
  msg_may_want_to_play_msg2: '{msg}可能想玩：{msg2}',
  online_msg_hours_ago: '{msg}小時前在線',
  select_content_to_send: '選擇要發送的內容',
  click_to_enter: '點擊輸入',
  hello_lets_play_if_you_want: '哈囉～想玩就約我喔！',
  hello_boss_want_to_play_games: '闆闆你好～打遊戲嗎？',
  youre_here_ive_been_waiting_for_you_for_a_long_time: '你來啦～等你好久了> <',
  custom: '自定義',
  sent_successfully: '發送成功',
  no_visitors_in_the_last_30_days: '最近30天暫無訪客',
  save: '儲存',
  self_promotion_for_game_companions: '陪玩師自推廣',
  promotion_tips: '推廣技巧',
  recommend_self_tip:
    '添加成功的陪玩師，指定技能會出現在新人特惠中，得到更多曝光率，更多新用戶的下單！',
  recommend_self_tip2: '目前只允許添加一個技能，12小時內只能更改一次唷',
  recommend_self_tip3: '超時未接單，技能已關閉',
  closed: '已關閉',
  modify: '修改',
  can_only_modify_the_skill_once_a_day: '每天只能修改一次技能',
  auto_reply: '自動回復',
  recommend_self_tip4: '低價攬新客，更多曝光值',
  enable_automatic_message_sending: '啟用自動發送訊息',
  choose_a_skill: '選擇技能',
  discount_offer: '折扣優惠',
  please_select_a_skill: '請選擇一項技能',
  discounted_price: '折扣後價格：$',
  self_promotion_skill_description: '自推廣技能說明',
  recommend_self_tip5:
    '1.新人優惠專區只有新註冊的用戶才會看到，每個新用戶只可以使用一次$25優惠價格下單。',
  recommend_self_tip6:
    '2. 陪玩師需支付50%的特別曝光費用，每次$40體驗單陪玩師會獲得$20收入!',
  recommend_self_tip7:
    '3.記得在優惠單給用戶留下美好的第一印象，每個新用戶都可能成為你的熟客，不要錯過開拓新客源的機會。',
  recommend_self_tip8: '4. 陪玩師自推廣每12小時內只可以提交一次申請唷～',
  automatic_reply_description: '自動回覆說明',
  recommend_self_tip9:
    '1.當用戶瀏覽過陪玩師的頁面並對陪玩師感興趣的時候，此功能將會自動嚮用戶打招呼，用戶回覆後將開啟與陪玩師的聊天、預約或者下單。',
  recommend_self_tip10:
    '2.自推廣開啟後，自動推送消息功能將會啟用。陪玩師可隨時手動開啟或關閉自動推送功能。',
  please_select_a_discount_offer: '請選擇折扣優惠',
  enable: '開啟',
  can_be_enabled_after_2400_tonight: '今晚24點之後可以開啟',
  disable_self_promotion_skill: '關閉自推廣技能',
  automatic_sending_field_cannot_be_empty: '自動發送欄位不可為空喔',
  new_user_auto_greeting: '自動招呼新客戶',
  new_user_auto_greeting_tip: '新用戶註冊後，系統會自動用此內容開啟1v1聊天',
  new_user_auto_greeting_voice: '語音訊息',
  new_user_auto_greeting_limit: '可被推送需綜合評分1000以上，且當時在線並為「現在可接單」狀態',
  enable_new_user_auto_greeting: '啟用自動招呼新客戶',
  new_user_auto_greeting_empty: '文字或語音至少填寫一項喔',
  submission_successful: '提交成功',
  recommend_self_tip11: '您有尚未儲存的變更，確認儲存嗎？',
  confirm_save: '確認儲存',
  recommend_self_tip12: '關閉後，該技能將不會出現在新人特惠，確認關閉嗎？',
  can_only_submit_once_a_day: '每天只能提交一次',
  submission_failed: '提交失敗',
  recommend_self_tip13: '請先添加技能，再開啟自動發送',
  score3_explain_popup_tip: '綜合評分越高，分配的曝光量越高',
  how_to_improve_the_comprehensive_rating: '如何提升綜合評分？',
  service_attitude: '服務態度',
  score3_explain_popup_tip2: '1. 多次下單是體驗品質的錶現',
  score3_explain_popup_tip3: '2. 玩家評價是體驗品質的重要標準',
  score3_explain_popup_tip4: '3. 訂單金額是體驗品質的肯定',
  service_quality: '服務質量',
  score3_explain_popup_tip5: '1. 即時回覆是積極響應的重要標準',
  score3_explain_popup_tip6: '2. 接單數量是積極響應的重要錶現',
  score3_explain_popup_tip7: '3. 主動聯繫查看過你的玩家',
  misconduct: '不良行為',
  score3_explain_popup_tip8: '如果您有不良行為，將會被扣除綜合評分',
  score3_explain_popup_tip9: '1. 在線不及時回覆玩家的信息',
  score3_explain_popup_tip10: '2. 被玩家評價差評',
  score3_explain_popup_tip11: '3. 遭檢舉涉及違規',
  score3_explain_popup_tip12:
    '綜合評分每日8點統一進行各維度結算，可能會有延遲，請耐心等待。',
  membership_level: '會員等級',
  you_have_exceeded_this_level: '您已超過此等級',
  vip_center_tip: '當前積分{msg}，還需{msg2}分升至{msg3}',
  current_points_msg: '當前積分',
  claim_now: '立即領取',
  score3_explain_popup_tip13: '領取後積分變更為{msg}，等級變更為{msg2}',
  score3_explain_popup_tip14:
    '1.下單或送禮每實付1幣，得1會員積分，積分可一直積累，升級後獲得對應等級獎勵，獎勵分爲以下三種類型：',
  score3_explain_popup_tip15:
    '2.裝扮類 - 頭像框、氣泡框、橫幅、坐騎實時獲得，永久有效。',
  score3_explain_popup_tip16:
    '優惠類 - 優惠券、鑽石、寶箱每月1號（早上9點後）至月末開放領取。領取後會消耗一定積分（獎勵等級要求積分的70%）並更新等級；如果不領取，積分不變，可一直積累。',
  score3_explain_popup_tip17: '特權類 - 根據當前所在等級實時生效。',
  example: '3舉例：',
  score3_explain_popup_tip18:
    '10月30日積分為50000，等級VIP9。31日下單10000幣，獲得10000積分，送禮10000幣（150000鑽）獲得10000積分，一共累積70000積分升為VIP10，立即獲得VIP10的裝扮和特權獎勵。11月1日上午9點後可領取到VIP10的優惠獎勵：50幣優惠券10張、6000鑽石。如果選擇領取，積分70000將扣除58888*70%後得到28778，等級更新為VIP8；如果不領取，積分不變且可一直積累。當月獎勵至月末前可領取。',
  score3_explain_popup_tip19: '5.平台保留最終解釋權。',
  score3_explain_popup_tip20: '本月可領取{msg}優惠獎勵',
  score3_explain_popup_tip21: '當前等級為{msg}，次月1日後可領取{msg2}獎勵',
  score3_explain_popup_tip22: '當前為{msg}，纍積更多會員積分獲得優惠獎勵！',
  score3_explain_popup_tip23: '領取獎勵',
  score3_explain_popup_tip24: '領取後等級將變爲{msg}',
  score3_explain_popup_tip26:
    '4.會員權益將在5月15日進行新一輪的調整，頭銜，挂件，靚號等全新裝扮上架。敬請期待！',
  claim_successful: '領取成功',
  score3_explain_popup_tip25: '請留意使用，當前等級為{msg}',
  gold_membership: '黃金會員',
  refund_application_in_progress: '申請退款中',
  already_refused_refund: '已拒絕退款',
  refund_application_has_been_rejected: '申請退款被拒絕',
  pending_payment: '待支付',
  refund_completed: '已退款',
  boosting_coach_confirmed_completion: '陪玩師確認完成',
  normal: '普通',
  gold: '黃金',
  black_gold: '黑金',
  legendary: '傳奇',
  pending_evaluation: '待評價',
  on_useSafari: '請用手機瀏覽器打開這個連結',
  on_callApp: 'Call App',
  order_allOrders: '全部訂單',
  order_activeOrders: '進行中的訂單',
  order_historyOrders: '歷史訂單',
  order_realCount: '實付',
  order_orderDetails: '訂單詳情',
  order_created: '已創建',
  order_acceptedOrder: '你接單了',
  order_orderCompleted: '訂單完成',
  order_Confirmorder: '是否確認接單？',
  order_Ordercanceled: '訂單取消',
  order_Rejectorder: '拒絕訂單',
  order_Rejectcancellation: '是否拒絕接單？',
  order_OnceConfirmorder: '接單之後，你就沒法取消訂單了喔。確認接單嗎？',
  order_responseto: '你沒有在10分鐘內接',
  order_gotit: '知道了',
  order_automaticallycanceled: '的訂單，訂單取消',
  order_YesCancel: '確認取消',
  order_YesCompleted: '確認完成',
  order_Yes: '確認',
  order_cancelOrder: '取消訂單',
  order_thinkAgain: '再想想',
  order_Orderconfirmed: '訂單已確認',
  order_rejectorder: '拒絕的話訂單就馬上會被取消喔，真的要狠心拒絕嗎？',
  order_Orderrejected: '訂單被拒絕',
  order_rejectcancellation:
    'Once you reject the cancellation request, the order will be in dispute and officially arbitrated. Still reject the cancellation request?',
  order_Successful: '成功了！',
  order_Successfully: '成功了！',
  order_noorders: '暫無訂單',
  order_acceptcancellation:
    'Once you accept the cancellation request, the order will be canceled immediately. Still accept the cancellation request?',
  order_Reject: '拒絕',
  order_Confirming: '待接單',
  order_inProgress: '進行中',
  order_cancellationRequest: '申訴中',
  order_Dispute: '申訴中',
  order_Confirm: '確認',
  order_active: '活躍訂單',
  order_history: '歷史訂單',
  order_acceptedorder: '陪玩師接單了',
  order_Writereview: '寫評論',
  order_Tapstars: '點亮星星給陪玩師評論喔',
  order_Surecancelorder: '是否取消訂單？',
  order_Surecompleteorder: '是否完成訂單？',
  order_reachedagreement: '客訴前請好好跟陪玩師溝通喔',
  order_permenantlyclosed: '確認要取消訂單嗎？',
  order_completeorder: '完成訂單後就沒法退款了喔',
  order_confirmacceptorder: '確認要取消訂單嗎？',
  order_Order: '訂單編號',
  order_canceled: '取消',
  order_Play: '一起玩',
  order_with: '和',
  order_Quantity: '數量',
  order_Subtotal: '總價',
  order_Discount: '優惠券扣減',
  order_Total: '實付',
  order_purchaseSkill: '購買技能',
  order_Note: '備註',
  order_CompleteOrder: '完成訂單',
  order_Orders: '訂單',
  order_myorder: '我的訂單',
  order_Received: '陪玩訂單',
  order_Placed: '我的訂單',
  order_Acceptcancellation: '是否接受取消申請？',
  follow_FollowList: '追蹤',
  follow_Following: '追蹤列錶',
  follow_Follower: '粉絲列錶',
  follow_Follow: '粉絲',
  follow_Followers: '粉絲',
  follow_followyourself: '不能追蹤你自己喔',
  follow_unfollow: '確定取消追蹤',
  follow_tokenLost: 'Token Lost',
  follow_noPlayerID: 'No PlayerID',
  follow_End: 'End',
  follow_nofollowers: '還沒有粉絲唷',
  follow_nofollowing: '還沒有追蹤的陪玩師，快去首頁看看唷',
  player_wirteReview: '寫評論',
  player_Review: '用戶評價',
  player_Reviews: '用戶評價',
  player_SeeMore: '展開',
  player_Skills: '技能項目',
  player_localtime: '當地時間',
  player_Buy: '下單',
  player_gamers: '陪玩師',
  player_moreSkills: '更多技能項目',
  player_findGamers: '發現更多陪玩師',
  player_noratings: '還沒有評論喔',
  player_SeeAll: '查看全部',
  player_Showmore: '快來豐富一下你的個人資料喔',
  player_suchempty: '空蕩蕩～',
  player_editprofile: '編輯個人資料',
  player_Followed: '已追蹤',
  player_Unfollow: '取消追蹤',
  player_Cancel: '取消',
  skill_Add: '添加技能',
  skill_Skills: '技能項目管理',
  skill_finishSetting: '完成設定',
  skill_Verifying: '審核中',
  skill_Level: '等級',
  skill_Rating: '評分',
  skill_ConnectionNumber: '接單數',
  skill_SelfIntroduction: '自我介紹',
  skill_chat: '聊天',
  skill_Whoops: '啊啊！',
  skill_OK: '確認',
  skill_Withdraw: '提領',
  skill_Noconnection: '網路連結斷開了！請檢查一下您的網路連結～',
  skill_tryAgain: '再試看看喔',
  skill_Price: '價格',
  skill_pricePer: '每半小時',
  skill_Earnings: '收入',
  skill_hourserved: '技能時長',
  skill_Transactions: '交易明細',
  skill_orderTaking: '上架技能',
  skill_onlyWithDraw:
    'Your earnings can only ly be withdrawn after a 30-day clearance.',
  record_contactus: '聯絡我們',
  record_ResolutionCenter: '客訴中心',
  record_Pendingclearance: '等待清算',
  record_sentemail: '確保你已發送郵件',
  record_Clearance: '清算',
  record_Hi: '您好',
  record_Sent: '我已經發郵件了',
  record_example: '範例',
  record_morehelp: '如果需要更多的幫助，請聯絡我們的官方郵箱。我們的郵箱是：',
  record_Game: '技能項目',
  record_SendEmail: '傳送郵件',
  record_rejectedcancellation:
    'Since you rejected the cancellation request, please send us an Email, writing down the reason and uploading files by attachment to support your side of view. You will get our relply within 72 hours. Our Email address is',
  record_applyingcancel:
    'Since you are applying to cancel the order, please send us an Email, writing down the reason and uploading files by attachment to support your view. You will get our relply within 72 hours. Our Email address is',
  record_OrderID: '訂單ID',
  record_Copy: '複製',
  record_Totalprice: '總付款金額',
  record_name: '暱稱',
  record_Withdrawn: '提領',
  record_Availabletowithdraw: '可提領收入',
  record_amountofevery: '每次至少提領NT$3000，最高提領NT$10000',
  record_onlywithdrawonce: '提領後3-5個工作日到賬',
  record_Yourearningscan: '滿NT$3000才能提領',
  record_reviewthecase: '確保已經發送郵件了',
  record_stepinthease: '如果你已發送客訴郵件，nicee將會介入處理',
  record_canwithdraw:
    'Every transaction will go through a 7-day clearance before you can withdraw.',
  recharge_details: '明細',
  select_amount: '請選擇金額',
  card_number: '卡號',
  security_code: '安全碼',
  remember_card_confirm: '我同意記住卡片資訊，以方便下次結賬',
  tax: '稅費',
  handling_fee_three: '手續費（由第三方現金流收取）',
  no_expired_coupons: '暫無失效優惠券',
  full_discount_offer2: '滿{msg}贈{msg2}',
  recharge_confirm: '去儲值',
  nicee_coins: 'NICEE幣',
  in_payment: '支付中',
  send_red_bag_orders: '發搶單紅包',
  red_bag_features: '紅包新功能',
  game_coaches_are_claiming_orders: '{msg}位陪玩師在搶單',
  amount_available_gift: '可贈送金額',
  gift_amount_info:
    '將收入贈送給好友，收入將以1：1換為nicee幣進入對方錢包帳戶，即時到賬。',
  gift_amount_info2:
    '狂歡大派送！首次贈送金額超過$1000,贈送方可額外獲得1000鑽石獎勵',
  confirm_gift: '確認贈送',
  pricing: '定價',
  price_setting: '價格設置',
  'add_more-pricing': '增添更多定價',
  unit: '單位',
  preferential: '優惠',
  full_discount_offer: '滿贈優惠',
  first_order_discount: '首單優惠',
  not_set: '未設定',
  grades_and_introductions: '等級和介紹',
  're-edit': '重新編輯',
  boosters_have_replied_please_select_your_preferred_booster:
    '{msg}位陪玩師回覆您了，請選擇您心儀的陪玩師',
  boosters_have_taken_orders_waiting_for_selection:
    '{msg}位陪玩師搶單了，等待選擇中',
  boosters_are_waiting_for_your_response_whom_would_you_like_to_choose:
    '{msg}位陪玩師在等待您的回覆，要選擇哪位呢？',
  withdraw_tip:
    '為保證您的帳戶安全，在進行提領時需要進行帳戶綁定和認證。在認證期間不能編輯資料或金額提領',
  go_to_certification: '去認證',
  manual_withdrawals: '人工提領',
  withdraw_able_amount: '可提領金額：',
  withdraw_limit: '（本周限額：{msg}）',
  withdraw_amount: '提領金額',
  withdraw_account: '提領至帳戶',
  withdrawal_verification: '未認證/資料填寫有誤？前往修改>>',
  user_name: '用戶名稱',
  withdraw_bankname: '提領銀行名',
  branch_code: '分行代碼',
  weChat_nickname: '微信昵稱',
  weChat_account: '微信帳號',
  read_and_agreed: '我已閱讀並同意',
  withdraw_method: '提領辦法',
  personal_data: '個人資料',
  real_name: '真實姓名',
  withdraw_account_validator: '身份證姓名不能為空',
  ID_number: '身份證號碼',
  withdraw_account_validator2: '請正確填寫您的身份證號碼',
  permanent_address: '戶籍地址',
  withdraw_account_validator3: '請正確填寫您的戶籍地址',
  front_photo_of_ID_card: '身份證正麵相片',
  back_photo_of_ID_card: '身份證反麵相片',
  withdraw_account_validator4: '請確保相片清晰',
  withdraw_account_validator5: '支持格式：jpg,jpeg,png',
  withdraw_account_validator6: '文件大小不要超過3M',
  bank_details: '銀行資料',
  bank_name: '銀行名稱',
  withdraw_account_validator7: '請正確填寫您的微信用戶名',
  wechat_account: '微信號',
  withdraw_account_validator8: '請正確填寫你的微信帳號',
  wechat_screen: '微信帳號頁麵截圖',
  upload_wechat_screen_tip: '請上傳微信帳號封麵圖',
  ranking_rules: '榜單規則',
  reward: '獎勵',
  first_unit_price: '首單價',
  '1_coin_purchase_restriction': '1幣限購',
  after_coupon_price: '券後價',
  order_quantity: '接單數量',
  user_rating: '用戶評分',
  evaluate: '評價',
  no_rating: '暫無評分',
  review_count: '{msg}條評價',
  chat_disable_tip: '請綁定手機來開通聊天功能',
  chat_disable_tip2: '已達訊息發送上限。完成一次任意金額充值，即可永久開通聊天功能，無限發送訊息。',
  bind_phone_confirm: '綁定手機',
  rating_detail: '該陪玩師的綜合評分較高，整體表現優異，快快選他吧~',
  rating_info:
    '綜合評分是對陪玩師整體表現的品質評定，代表了陪玩師的態度與品質。',
  ask_player: '問陪玩師',
  last_three_codes: '後三碼',
  give_diamond: '送{msg}鑽',
  ability_attributes: '技能屬性',
  skill_profiles: '技能檔案',
  'average_pricing_skill:': '該技能平均定價:',
  min_red_bag: '紅包不能小於{msg}幣',
  remarks_sounds_good: '備註 (選填)：例如“聲音好聽”等',
  red_bag_order_title: '使用“紅包”獲得更多搶單！',
  red_bag_order_info:
    '在約單時設定紅包總金額，發出約單後，前15位搶單的陪玩師將會分得“隨機”金額紅包。若搶單人數不足15人，剩餘金額將在約單結束後退回。（目前本功能無佣金）',
  get_more_bosses: '釋放即召喚更多活躍中的老闆...',
  pull_up_refresh: '上拉刷新~',
  vocality_updating: '更新中',
  potential: '潛力',
  recently_placed_order: '最近下單',
  new_user_not_order: '新用戶 暫未下單',
  say_hi: '打招呼',
  say_hello_success: '打招呼成功',
  received_friend_ID: '受贈好友ID',
  recipient_nickname: '受贈方暱稱',
  user_not_exist: '該用戶不存在',
  unable_gift_oneself: '無法贈送給自己',
  please_enter_valid_friend_ID: '請輸入有效的好友ID',
  fill_in_gift_amount: '請填寫贈送金額',
  more_than_price: '贈送金額超出可贈送',
  gift_success: '贈送成功',
  gift_amount_user: '贈送{msg}金額給{msg2}',
  withdraw_tip2: '每週最多可提領新台幣19999，單筆提領最低要求為新台幣1000。',
  withdraw_tip3: '每週一8:00刷新當週可提領限額。',
  withdraw_tip4: '申請提領至撥款，時間需要3-7個工作日，請耐心等待。',
  withdraw_tip5: '若國稅局要求，nicee有義務要配合國稅局協助提供相關資料。',
  withdraw_tip6:
    '1.依據臺灣相關法律規定，申請提領的用戶提供相關所需文件以利nicee官方協助完成勞務報酬單填寫，首次進行提現流程時，會需要上傳您的身份證正反面，若資料上有任何問題，nicee官方將與您聯繫相關事宜。',
  withdraw_tip7:
    '2.本人擔保所提交之所有資料確認為本人所有，若有任何事情，本人願意負擔法律責任。',
  withdraw_tip8:
    '3. 申請提領後，個人資料及銀行帳戶將自動綁定，如需更改請向客服反映。',
  withdraw_tip9:
    '4.平台對用戶提交之所有圖文資料進行格式校驗。因錯誤填寫帳戶等個人原因導致的帳戶錯匯或其他問題，平台概不負責。',
  committing: '提交中...',
  account_under_review: '帳戶審核中',
  withdraw_diabled: '提領帳戶審核中，暫時不可修改',
  not_logged_in: '未登錄',
  exceeded_withdrawal_limit: '已超過可提領額度',
  withdrawal_account: '提領帳戶',
  weChat_withdrawal: '微信提領',
  withdraw_diabled2: '您的帳戶認證未通過，請重新認證',
  withdraw_validator1: '單次提領不能超過{msg}',
  withdraw_validator2: '請輸入整數',
  withdraw_validator3: '每次提領金額不能小於{msg}',
  withdraw_validator4: '提取金額不能為0',
  withdraw_diabled3: '提領帳戶審核中，暫時不可提交',
  branch_name: '分行名稱',
  account_number: '帳戶號碼',
  confirm_submission: '確認提交',
  withdraw_account_validator9: '身份證姓名需與銀行資料開戶名相同',
  withdraw_account_validator10: '請輸入2-10位漢字',
  withdraw_account_validator11: '請輸入10-14位正確的身份證號碼',
  withdraw_account_validator12: '正面相片不能為空',
  withdraw_account_validator13: '反面相片不能為空',
  click_select_bank: '点击选择银行',
  withdraw_account_validator14: '請正確填寫您的Paypal用戶名',
  withdraw_account_validator15: '請正確填寫您的分行名稱（上限20個字符）',
  withdraw_account_validator16: '請輸入1-20位字符',
  withdraw_account_validator17: '微信信息不能為空',
  withdraw_account_validator18: '請正確填寫您的分行名稱（上限20個字符）',
  withdraw_account_validator19: '請正確填寫您的Paypal電子郵箱',
  withdraw_account_validator20:
    '請正確填寫您的帳戶號碼（只允許數字，10-14位之間）',
  withdraw_account_validator21: '電子郵箱不符合規則',
  withdraw_account_validator22: '請輸入10~14位数字',
  withdraw_account_validator23: '存摺信息頁不能為空',
  upload_bank_screen_tip: '請上傳帶銀行帳號的存摺頁面',
  bank_screen: '存摺信息頁(*帶銀行帳號的頁面)',
  applying_to_become_playmate: '申請成為陪玩師',
  registered_playmate_info1: 'nicee陪玩誠邀你',
  registered_playmate_info2: '成為我們的陪玩師',
  registered_playmate_info3: '我們等待這樣的你：',
  registered_playmate_info4: '風趣幽默，熱愛聊天；熱愛遊戲，也熱愛交友。',
  registered_playmate_info5: '無論處於好奇或者職業，都希望把陪玩師做好。',
  registered_playmate_info6:
    '如果你是這樣的人，快快點擊申請入駐，開啟你的陪玩師之旅吧！',
  registered_playmate_info7: '我已閱讀並同意',
  registered_playmate_info8: '《nicee陪玩師行為守則》',
  registered_playmate_info9: '《服務協議與隱私條款》',
  registered_playmate_info10: '我同意以上條款，並立即申請',
  registered_playmate_step_info1: '簡單三步驟 nicee幫你開心玩！輕鬆賺',
  registered_playmate_step_info2: '入門測試',
  registered_playmate_step_info3:
    '能讓您快速認識nicee，要認真閱讀並完成測驗喔！',
  registered_playmate_step_info4: '恭喜成功通過測試，趕快進行下一步填寫資料吧~',
  registered_playmate_step_info5: '重新測試',
  registered_playmate_step_info6: '去測試',
  registered_playmate_step_info7: '資料填寫',
  registered_playmate_step_info8:
    '快展現最有特色的你！豐富有趣的內容可以更好的吸引用戶，獲得曝光喲~',
  registered_playmate_step_info9: '去填寫',
  registered_playmate_step_info10: '資格審核',
  registered_playmate_step_info11:
    '審核會在1天工作日內完成，要仔細填寫步驟二的資料哦~祝您順利過審！~',
  registered_playmate_question_info1: '選擇有誤，請重選。',
  registered_playmate_question_info2: '查看提示',
  registered_playmate_question_info3: '下一題',
  registered_playmate_question_info4: '提交測試',
  registered_playmate_question_info5:
    '中途退出的話，此前的答題將會被清零哦，請慎重考慮',
  registered_playmate_question_info6: '繼續答題',
  registered_playmate_question_info7: '堅持退出',
  registered_playmate_question_info8: '請先完成題目再继续下一步喔',
  registered_playmate_question1: '1：陪玩師是誰？（多選）',
  registered_playmate_question2: '遊戲高手，帶人體驗電競快感',
  registered_playmate_question3: '聲甜幽默，陪伴消磨無聊時間',
  registered_playmate_question4: '歌聲動人，給人帶來聽覺享受',
  registered_playmate_question5:
    '塔羅、星座、情感、提醒、繪圖…人盡其才必有我用。',
  registered_playmate_question6: '2：如何賺錢？（多選）',
  registered_playmate_question7: '創建有吸引力的技能介紹',
  registered_playmate_question8: '在約單大廳積極搶單',
  registered_playmate_question9: '在動態廣場發佈吸引人的內容推廣自己',
  registered_playmate_question10:
    '在遊戲或社交媒介中展示自己，並帶上Nicee暱稱，便於人查找',
  registered_playmate_question11:
    '維護好已有客戶，主動提供關心，創造可持續的服務',
  registered_playmate_question12: '樂觀心態，職業態度',
  registered_playmate_question13: '3：怎樣提領收入？（多選）',
  registered_playmate_question14: '實名身份',
  registered_playmate_question15: '耐心等待系統結算入賬',
  registered_playmate_question16: '綁定收款銀行帳戶',
  registered_playmate_question17: '催促客服加快提領',
  registered_playmate_question18: '出現存疑款項時與客服消極溝通',
  registered_playmate_question19: '4：怎樣保護自己？（多選）',
  registered_playmate_question20:
    '對於大額訂單，切記確保交易內容、聊天記錄留底可查',
  registered_playmate_question21:
    '如發現非法的用戶，積極檢舉，維護平台與其他陪玩師的安全',
  registered_playmate_question22: '出現糾紛、爭議，主動與客服聯繫，尋求解決',
  registered_playmate_question23:
    '不尊重用戶隱私，將客戶聊天截圖直接公佈到廣場',
  registered_playmate_question24: '通過網路人肉，線下圍堵他人',
  registered_playmate_question25:
    '5：哪些行為平台嚴令禁止並會嚴厲處罰？（多選）',
  registered_playmate_question26: '發佈無關遊戲或服務的內容',
  registered_playmate_question27: '詐騙',
  registered_playmate_question28: '對他人進行人身攻擊',
  registered_playmate_question29: '與非法金融團伙合作洗錢',
  registered_playmate_question30: '6：作為新人，怎樣開始第一步？（多選）',
  registered_playmate_question31: '發超多超美自拍',
  registered_playmate_question32: '發超多超厲害的遊戲戰績、視頻',
  registered_playmate_question33:
    '將IG、Tiktok、Twitch、Youtube個人頁放入介紹便於了解',
  registered_playmate_question34: '積極搶單',
  registered_playmate_tip1:
    'Nicee是開放的虛擬服務交易平台，陪玩師可發揮想象空間，在合法範圍自由創建虛擬商品並自由定價能提供的服務。',
  registered_playmate_tip2: '技能介紹中如何展現自己，是促成第一單的關鍵',
  registered_playmate_tip3:
    '請重視為對你下過單的所有客戶，他們將會是未來最客觀的收入來源',
  registered_playmate_tip4:
    '在遊戲和交友類社媒中分享自己，能獲得大量精準、潛在客戶',
  registered_playmate_tip5:
    '積極、樂天、富有感染力的心態，永遠都是你最珍貴資產',
  registered_playmate_tip6:
    '在用戶確認完成訂單后，平台將對資金來源進行風險評估，此時需要與銀行和金流方串接。只有在資金確認安全情況下才能入賬完成結算。按過往經驗，絕大部分款項結算在1-2天內完成，但如果資金來源在串接評估中報警，入賬將會產生延後。此時需要用戶積極與客服溝通，提供相應真誠接單材料，直至風險解除。當資金結算完成，陪玩師可進行提領，請確保實名信息與銀行帳戶一致，以確保官方正常打款。',
  registered_playmate_tip7: '財務為統一流程，催促客服不會加快提領。',
  registered_playmate_tip8:
    '安全永遠放在第一位。開放的平台會遇到各種需求的用戶，請在有遇到威脅，或有損自身權益時，第一時間聯繫客服。提供真實、客觀、完整的相關溝通記錄和交易記錄，以便於官方進行處理。如有必要，官方會配合用戶與警方進行情況同步，但請勿在未握有明確證據或犯罪事實的情況下衝動行為或盲目報警。',
  registered_playmate_tip9:
    '參與詐騙、洗錢金融犯罪活動，屬於嚴重違法行為，平台將一律提告。對於直接參與者，平台將連同實名資料和行為情況移交法律；未直接參與但知情者，對於平台或他人利益損失，將根據平台用戶協議進行封號、停止結算和提領。',
  registered_playmate_tip10:
    '打造引力是新人開始必不可少的第一步。要相信自己永遠都是獨一無二最好的！',
  registered_playmate_data_info1: '填寫個人資料',
  registered_playmate_data_info2: '頭像',
  registered_playmate_data_info3: '請確保個人頭像清晰，真實',
  registered_playmate_data_info4: '請上傳頭像',
  registered_playmate_data_info5: '暱稱',
  registered_playmate_data_info6: '請輸入暱稱',
  registered_playmate_data_info7: '暱稱須在3-30個字之間',
  registered_playmate_data_info8: '年龄',
  registered_playmate_data_info9: '請輸入年龄',
  registered_playmate_data_info10: '請設置年齡',
  registered_playmate_data_info11: '禁止未滿十八歲用戶申請成為陪玩師',
  registered_playmate_data_info12: '請選擇性別',
  registered_playmate_data_info13: '綁定手機號',
  registered_playmate_data_info14: '用於個人帳號登錄及管理，不對外展示。',
  registered_playmate_data_info15: '已綁定手機號',
  registered_playmate_data_info17: '請綁定手機',
  registered_playmate_data_info18: '下一步',
  registered_playmate_data_info19: '請上傳頭像',
  registered_playmate_data_info20: '暱稱須在3-30個字之間',
  registered_playmate_data_info21: '請選擇性別',
  registered_playmate_data_info22: '請綁定手機',
  registered_playmate_data_info23: '請設置年齡',
  registered_playmate_data_info24: '開通第一個技能：語音聊天',
  registered_playmate_data_info25:
    '該技能為默認必選。可在資料審核通過後，選擇是否開啟接單以及調整價格。',
  registered_playmate_data_info26: '我的聲音類型',
  registered_playmate_data_info27: '技能介紹',
  registered_playmate_data_info28: '描述你的特點以及該技能提供的服務內容。',
  registered_playmate_data_info29: '內容不少於20字',
  registered_playmate_data_info30: '錄音',
  registered_playmate_data_info31: '150幣/半小時',
  registered_playmate_data_info32:
    '超棒的！我們正在審核你的資料，24小時內會回復你唷',
  registered_playmate_data_info33: '知道了',
  registered_playmate_data_info34: '請選擇一項你想申請的技能',
  registered_playmate_data_info35: '網遊競技',
  registered_playmate_data_info36: '線上娛樂',
  registered_playmate_data_info37: '互助交流',
  registered_playmate_data_info38: '其他',
  registered_playmate_data_info39: '市集最多可申請3個技能',
  registered_playmate_data_info40: '請編輯你的技能{msg}檔案',
  registered_playmate_data_info41: '請選擇最符合你的技能類別',
  registered_playmate_data_info42: '選擇你的遊戲等級',
  registered_playmate_data_info43: '技能標題',
  registered_playmate_data_info44:
    '請為你的技能設置標題，違規內容會使審核不通過喔(標題不超過6個字符)',
  registered_playmate_data_info45: '你的技能標題',
  registered_playmate_data_info46: '上傳圖片',
  registered_playmate_data_info47:
    '請上傳能證明你相關的技能的截圖，保證截圖清晰，相片中不允許出現色情，暴力等違法內容。',
  registered_playmate_data_info48: '(選填)',
  registered_playmate_data_info49: '範例',
  registered_playmate_data_info50:
    '非遊戲技能展示一張「聲鑑卡」可有效幫助提升吸引力。若需製作可聯絡',
  registered_playmate_data_info51: '平台聲鑑師',
  registered_playmate_data_info52: '獲得幫助。',
  registered_playmate_data_info53: '展示信息隱藏ID請點擊',
  registered_playmate_data_info54: '收起',
  registered_playmate_data_info55: '我要隱藏ID',
  registered_playmate_data_info56:
    '展示訊息\n：帶有遊戲ID的段位截圖將僅作為內部審核，技能通過後將展示下方圖片訊息',
  registered_playmate_data_info57: '遊戲認證（選填）',
  registered_playmate_data_info58:
    '遊戲ID僅限平台審核使用，審核通過後將獲得平台對您技能水準的認證喔！',
  registered_playmate_data_info59: '請輸入您用於接單的遊戲ID',
  registered_playmate_data_info60: '請選擇遊戲生涯最精通的模式',
  registered_playmate_data_info61: '自我介紹',
  registered_playmate_data_info62:
    '對於技能簡單生動的介紹，更容易通過審核以及獲得用戶的青睞喔！(請輸入至少20個字符)',
  registered_playmate_data_info63: '實況主',
  registered_playmate_data_info64: 'PS：申請實況主標籤請附上實況鏈接喔～',
  registered_playmate_data_info65:
    '例如：哈囉 我是XX 主要技能是英雄聯盟 主輔助 擅長的角色 XXX，歡迎一起玩',
  registered_playmate_data_info66: '選擇模式',
  registered_playmate_data_info67:
    '你的資料已進入審核，請留意查看消息或刷新本頁，預計在1個工作日內收到結果。',
  registered_playmate_data_info68: '資格審核',
  registered_playmate_data_info69: '首單優惠',
  registered_playmate_data_info70: '首單立減',
  registered_playmate_data_info71: '增添首單優惠',
  registered_playmate_data_info72: '用戶對您下的第一單可以享受您所設置的首單價',
  registered_playmate_data_info73:
    '優惠僅對已在平台下過至少一單的用戶生效，且不能與新人特惠同時使用',
  registered_playmate_data_info74:
    '開啟此優惠後，若有服務品質上的檢舉，一經核實將取消此資格，請陪玩師特別留意',
  registered_playmate_data_info75: '模式（單位為7分鐘，模式默認為7分鐘嚐鮮）',
  registered_playmate_data_info76:
    '例：單位選擇局，設定輸入為積分模式，則價格設定為積分模式100幣/局(內容不超過8個字符)',
  registered_playmate_data_info77: '單位為小時，模式不可選擇',
  registered_playmate_data_info78: '模式名稱不符合標準，已重新設定',
  registered_playmate_data_info79: '單位設定',
  registered_playmate_data_info80: '您當前設置的技能單位為：{msg}天',
  registered_playmate_data_info81:
    '請核實價格是否準確，並與用戶商議陪玩時長，後續因為價格單位設置引起的訂單糾紛由陪玩師自行承擔',
  registered_playmate_data_info82: '計價單位模式重複設定',
  edit_success: '修改成功',
  add_success: '添加成功',
  edit_failed: '修改失敗',
  add_failed: '添加失敗',
  registered_playmate_data_info83: '7分鐘嚐鮮',
  registered_playmate_data_info84:
    '極速體驗價格設定區間僅為30-40nicee幣，請重新設置',
  price_range_minutes7: '價格必須在30-40之間喔',
  price_range_limit: '價格必須在{priceLeft}-{priceRight}之間喔',
  price_range_invalid: '請輸入有效價格',
  custom_price: '自定義價格',
  custom_price_placeholder: '輸入價格',
  save_failed: '保存失敗',
  skill_introduction_not_less_than_30_words: '技能介紹不少於20字',
  the_content_you_entered_contains_sensitive_words_please_reenter:
    '您輸入的內容涵蓋敏感詞，請重新輸入',
  application_submission_failed: '提交申請失敗',
  you_applied_to_become_a_game_buddy: '你申請成為陪玩師',
  delete_first_order_discount: '是否刪除首單優惠?',
  repurchase_order: '回購訂單',
  order_refund: '訂單退款',
  apply_for_refund: '申請退款',
  refund_details: '退款詳情',
  write_review: '寫評價',
  view_review: '查看評價',
  accept_order_immediately: '立即接單',
  place_another_order: '再來一單',
  reason_for_declining_refund: '拒絕退款理由',
  please_enter_reason_for_declining_refund: '請輸入拒絕退款理由',
  refund_application_details: '申請退款詳情',
  initiate_refund_application: '發起申請退款',
  reason_for_appeal: '申訴理由',
  waiting_for_game_buddy_to_process_your_order_cancellation_request:
    '等待陪玩師處理您的取消訂單申請',
  waiting_for_the_other_party_to_process_your_order_cancellation_request:
    '等待您處對方的取消訂單申請',
  rate_game_buddy: '評價陪玩師',
  star_rating_cannot_be_lower_than_the_original_rating_and_each_person_has_only_one_opportunity_to_modify_the_rating:
    '注：評價的星數不可低於原有評價喔，且每人只有一次修改評價的機會喔',
  you_can_modify_the_rating_within_48_hours_after_the_initial_rating_the_star_rating_cannot_be_lower_than_the_original_rating_and_each_rating_can_only_be_modified_once:
    '注：首次完成評價後48小時內可修改評價，評價的星數不可低於原有評價，且每條評價只可修改一次喔~',
  tap_to_rate: '輕點評分',
  please_enter_detailed_review_to_increase_exposure_for_him:
    '請輸入詳細評價，幫他增加曝光吧～',
  please_enter_detailed_review_to_help_the_game_buddy_improve:
    '請輸入詳細評價，幫助陪玩師改進吧～',
  add_tags: '添加標籤（最多3個）',
  anonymous_rating: '匿名評價',
  rated_you: '評價了你',
  you_rated_the_game_buddy: '你評價了陪玩師',
  modify_rating: '修改評價',
  you_rated: '你評價了',
  dislike: '不喜歡',
  '1_star_very_unsatisfied': '1分，很不滿意',
  '2_stars_not_satisfied': '2分，不太滿意',
  '3_stars_average': '3分，一般',
  '4_stars_pretty_good': '4分，還不錯',
  '5_stars_excellent': '5分，非常棒',
  confirm_taking_this_order: '確認接下這單?',
  'providing_high-quality_skills_and_receiving_detailed_five-star_reviews_can_help_you_get_more_exposure_and_orders':
    '提供高質量技能並且收穫有詳細描述的五星好評，可以幫助您獲得更多曝光和訂單喔！',
  confirm_accepting_order: '確認接單',
  confirm_initiating_refund_request: '確認發起申請退款嗎?',
  after_initiating_a_refund_request_you_need_to_fill_in_the_reason_for_refund_only_after_the_game_buddy_agrees_can_the_order_be_cancelled_if_there_is_a_disagreement_you_can_contact_customer_service:
    '發起申請退款後需要填寫申請退款理由，陪玩師同意後才可以取消訂單，如出現意見不一致，可聯繫客服喔。',
  confirm_initiating: '確認發起',
  confirm_rejecting_refund: '確認拒絕退款嗎?',
  after_confirming_rejecting_the_refund_the_platform_will_intervene_and_arbitrate_as_needed_the_arbitration_result_will_be_settled_within_seven_days_as_cancellation_or_completion:
    '確定拒絕退款後，平台方會按需要進行介入仲裁，視仲裁結果七天內定為取消訂單或完成。',
  reject_refund: '拒絕退款',
  continue_applying_for_refund: '繼續申請退款',
  you_only_have_one_opportunity_to_modify_the_rating_confirm_submission:
    '只有一次修改評價的機會，確認提交嗎？',
  modify_rating_success: '修改評價成功',
  rating_success: '評價成功',
  please_fill_in_review_content: '請填寫評價內容',
  the_content_you_entered_may_contain_sensitive_terms_please_reenter:
    '您輸入的內容可能包含敏感詞彙，請重新輸入',
  hours: '時',
  minutes: '分',
  seconds: '秒',
  confirm_canceling_order: '確認取消訂單嗎?',
  occupancy_amount_is: '{msg}的佔有金額為',
  the_currently_set_initial_guardian_amount_is: '當前設定初始守護金額為',
  guardian_privileges: '守護者特權',
  first_screen_guardian_position: '首屏守護專位',
  comment_section_nickname_highlight: '評論區暱稱高亮',
  original_price: '原價:',
  you_still_need: '您還差',
  set_initial_guardian_amount: '設定初始守護金額',
  guard_tip1:
    '1.在此處可以設定佔領守護位所需要的初始金額以及同一用戶續費守護位的金額',
  guard_tip2: '2.位上無人時此設定立刻生效，位上有人時則作為他的續費金額',
  guard_tip3: '3.互為對方守護者時即達成相互守護，專屬頭像框將隨之升級',
  guard_tip4: '4.每30天可修改一次設置',
  guard_tip5: '1.在此處設定佔領守護位或續費守護位所需要之金額',
  guard_tip6:
    '2.守護位上無人時佔領立刻生效；守護位上有人時則為原守護者之續費金額',
  guard_tip7: '3.互為對方守護者時即達成相互守護，專屬頭像框將隨之升級',
  guard_tip8: '4.每30天可修改一次設置',
  guardian_gold_setting: '守護金設定',
  extend_guardian_period: '延長守護期',
  occupy_guardian_position: '佔領守護位',
  cannot_modify_within_30_days_after_last_setting:
    '完成設置後30天內不能再次修改',
  setting_successful: '設置成功',
  less_than_30_days_since_last_setting: '距離上次設置未滿30天',
  game_buddy_accepts_order: '陪玩師接單',
  game_buddy_confirms_completion: '陪玩師確認完成',
  game_buddy_refunds: '陪玩師退款',
  full_refund: '全部退款',
  partial_refund: '部分退款',
  game_buddy_rejects_refund: '陪玩師拒絕退款',
  refund_successful: '退款成功',
  repurchase_rate: '復購率',
  place_order_now: '立即下單',
  payment_method: '付款方式',
  nicee_balance_payment: 'nicee餘額支付',
  available: '可用',
  add_credit_card_payment: '添加信用卡支付',
  pay_with: '支付{msg}幣',
  promotion_details: '滿贈活動',
  limited_to_one_order_cannot_be_combined_with_other_discounts:
    '限購一單，不可與其他優惠疊加使用',
  currently_msg_available: '當前{msg}张可用',
  order_amount_less_than: '訂單金額未滿',
  new_user_exclusive_discount: '新人專屬折扣',
  pay: '支付',
  product_name: '商品名稱',
  order_amount: '訂單金額',
  credit_card_debit_card_number: '信用卡/金融卡卡號',
  proceed_to_payment: '前往付款',
  select_credit_card_debit_card: '選擇信用卡/金融卡',
  or: '或者',
  use_another_credit_card_debit_card: '使用其他信用卡/金融卡',
  automatically_select_randomly_if_expired: '超時自動隨機選擇',
  only_visible_to_those_who_meet_the_order_requirements: '僅符合搶單條件者可見',
  delete_pricing: '是否刪除該定價?',
  please_set_the_price: '請設定價格',
  create_room: '創建房間',
  enter_password: '輸入密碼',
  incorrect_password: '密碼輸入錯誤',
  overall_ranking: '總榜單',
  want_to_delete_this_update: '要刪除該條動態嗎？',
  do_not_delete: '不刪除',
  countdown_prompt: '請在倒計時結束前完成選擇喔',
  countdown_prompt2: '超時取消',
  countdown_prompt3: '将导致当日无法继续约单',
  select_he: '選他',
  next_time_ok: '下次吧',
  take_on_order: '確認接下這單?',
  order_acceptance_prompt:
    '提供高質量服務並且收穫有詳細描述的五星好評，可以幫助您獲得更多曝光和訂單喔！',
  refund_application_prompt:
    '申請退款前請確保您已經跟用戶溝通過，或者有用戶違規證據。若無故取消被舉報後可能導致您的技能被下架',
  people: '人',
  order_creation_in_progress: '訂單創建中',
  official_line: '官方line',
  open_official_line_info: '已複製官方line鏈接，請到瀏覽器中打開',
  official_instagram: '官方instagram',
  room_not_open: '房間未開放',
  need_password: '需要輸入密碼',
  private_remittance: '私下匯款',
  member_benefits_description4:
    '4.靚號，定制頭銜，定制挂件，定制頭框需在達到對應等級后，聯係Nicee小管家進行定制。',
  member_benefits_description5:
    '5.6位靚號最多可選5連號，5位靚號最多可選4連號，4位靚號最多可選3連號。分別示例：688888，68888，6888',
  member_benefits_description6:
    '5.會員權益將不定時進行更新，將於每次更新前15日内在“等級規則”内預告，平台保留最終解釋權。',
  vouchers: '折價券',
  party: '派對',
  teacher_now: '立即教學',
  teacher_rank: '教學榜',
  first_order_tips: '首單價格低於50幣 有機會上首頁推薦哦~',
  first_order_price: '首單價格',
  add_first_order_price: '增添首單價格',
  enter_friend_invitation_code2: '輸入好友邀請碼',
  not_get: '未獲得',
  invitation_code_error: '填寫的邀請碼有錯誤，請檢查重試',
  paste_invitation_code: '粘貼邀請碼',
  click_paste_invitation_code: '點擊輸入好友邀請碼',
  tag_hot: '人氣',
  tag_minutes7: '嚐鮮',
  tag_nice: '口碑',
  tag_new: '新人',
  bill: '賬單',
  most_recently_joined: '最新加入',
  latest_release: '最新發佈',
  refund_application_in_progress: '申請退款中',
  add_full_discount_offer: '增添滿贈優惠',
  h5_live_setting_title: '直播設定',
  h5_live_detection: '直播偵測',
  h5_live_detection_tip: '直播時，直播畫面將出現在個人動態',
  h5_live_title: '直播標題',
  h5_live_title_placeholder: '點擊輸入直播標題',
  h5_live_url: '直播鏈接',
  h5_live_url_placeholder: '點擊輸入直播鏈接',
  h5_live_supported_platform: '支持平台',
  h5_live_cover: '直播封面',
  h5_live_cover_tip: '重新上傳可更新封面',
  h5_live_url_required: '鏈接不能為空',
  h5_live_url_invalid: '不是有效的链接',
  h5_live_title_required: '標題不能為空',
  h5_live_cover_required: '封面不能為空',
  save_successfully: '保存成功',
  h5_order_comment_feeling_title: '您對這位用戶的感受如何？',
  h5_order_comment_anonymous_done: '已匿名',
  h5_order_comment_choose_reason: '請選擇原因，幫助平台維持健康生態',
  h5_order_comment_feedback_placeholder:
    '您的反饋會讓我們做的更好(不超過200字)',
  h5_order_comment_privacy_tip: '評價不會顯示給其他用戶，僅為數據收集',
  h5_order_comment_submit: '提交評價',
  h5_order_comment_exit_message: '退出將放棄本次評價，確認退出嗎？',
  h5_order_comment_confirm_exit: '確認退出',
  h5_month_day: '{month}月{day}日',
  h5_gift_total_count: '禮物總數',
  h5_gift_wall_empty: '目前還沒有收到禮物，要加油喔',
  h5_yomi_empty: '暫無可用遊戲',
  h5_bind_invitation_code: '綁定邀請碼',
  h5_player_list_default_title: '開黑專區',
  h5_new_user_coupon: '新人優惠券',
  h5_fans_count: '粉絲數',
  h5_full_discount_offer: '滿{startNum}贈{giftNum}',
  h5_recharge_before_send_gift: '請您到儲值頁面先儲值再送出禮物',
  h5_selected_gift_not_exist: '您選擇的禮物不存在',
  h5_gift_rejected: '您的禮物已被拒絕接受',
  h5_balance_not_enough_recharge_first: '您的余額不足，請先儲值喔',
  h5_gift_send_failed: '禮物發送失敗',
  h5_gift_count_1: '一心一意',
  h5_gift_count_10: '十全十美',
  h5_gift_count_99: '長長久久',
  h5_gift_count_188: '要抱抱',
  h5_gift_count_520: '我愛你',
  h5_gift_count_1314: '一生一世',
  h5_gift_snowman_not_enough:
    '您所擁有的暖心雪人數量不足，是否前往活動頁購買',
  h5_gift_bell_need_buy: '您還需要購買{count}個聖誕鈴鐺，是否確認繼續？',
  h5_gift_deprecated: '已下架',
  h5_player_detail_chat_before_order_title: '下單前聊一聊',
  h5_player_detail_chat_before_order_text:
    '下單前聊一聊有助於確認陪玩師資料',
  h5_player_detail_order_direct: '直接下單',
  h5_player_detail_go_chat: '去聊天',
  h5_player_detail_no_remind: '不再提醒',
  h5_player_detail_tag_explain: '標籤說明',
  h5_player_detail_tag_rebought: '回單王',
  h5_player_detail_tag_rebought_desc: '人均回購單數排名TOP20（近90天）',
  h5_player_detail_tag_nice: '夯口碑',
  h5_player_detail_tag_nice_desc: '入選首頁評價推薦',
  h5_player_detail_tag_hot: '高人氣',
  h5_player_detail_tag_hot_desc: '接單多',
  h5_player_detail_tag_new: '優質新人',
  h5_player_detail_tag_new_desc: '近期入駐的優質陪玩師',
  h5_player_detail_tag_position: '位置認證',
  h5_player_detail_tag_position_desc: '此位置表現優異',
  h5_guardian_gift_reach: '送禮達',
  h5_guardian_can_be_guardian: '可成為守護者',
  h5_guardian_need_more_to_be_guardian: '您還差{count}💎可成為守護者',
  h5_list_separator: '，',
  h5_player_detail_comment_player_reply: '陪玩師回覆',
  h5_player_detail_comment_empty_self: '暫時還沒有人評價過你喔～',
  h5_player_detail_comment_empty_other: '暫時還沒有人評價過他喔～',
  h5_player_detail_comment_reply_placeholder: '回應一下吧～',
  h5_player_detail_comment_reply_confirm:
    '僅有一次回覆評價的機會，提交後不可修改喔~',
  h5_player_detail_comment_hidden_default: '-已隱藏{count}條默認好評-',
  h5_gift_icon_title: '送禮勳章是什麼？',
  h5_gift_icon_desc1: '送禮勳章是用戶在nicee通過送禮物獲得的勳章',
  h5_gift_icon_desc2:
    '該勳章會展示在評論的暱稱後，語音房公屏的暱稱後及個人資料卡片',
  h5_gift_icon_rule_title: '發放規則：',
  h5_gift_icon_rule_time: '· 送禮勳章每日6點計算發放',
  h5_gift_icon_level1_line1: '近三十日平台送禮金額大於等於500新台幣，',
  h5_gift_icon_level1_line2: '小於1000新台幣可獲得',
  h5_gift_icon_level2_line1: '近三十日平台送禮金額大於等於1000新台幣，',
  h5_gift_icon_level2_line2: '小於2500新台幣可獲得',
  h5_gift_icon_level3_line1: '近三十日平台送禮金額大於等於2500新台幣',
  h5_gift_icon_level3_line2: '可獲得',
  h5_limited_time: '限時',
  h5_player_list_super_cheap: '超便宜',
  h5_player_list_newbie: '小萌新',
  h5_refund_no_reply_auto_refund:
    '24小時內陪玩師沒回覆，退款將自動生效，金額返回您的帳戶',
  h5_refund_negotiate_tip:
    '若對金額有異議可與陪玩師進一步溝通並讓陪玩師為您退款，若無法達成一致，可申請客服介入解決。若無處理，訂單將在7天候自動完成。',
  h5_refund_reason_completed: '已服務完畢',
  h5_refund_reason_malicious: '用戶惡意退單',
  h5_request_error: '請求出錯了!',
  h5_minutes_ago: '{msg}分鐘前',
  h5_hours_ago: '{msg}小時前',
  h5_days_ago: '{msg}天前',
  h5_relegation_privilege_title: '什麼是保級特權，如何獲得？',
  h5_relegation_privilege_desc:
    '領取等級獎勵時如果使用“保級特權”，將不扣除任何等級積分。若連續3次達到傳奇等級（VIP13及以上）且未使用保級特權，可增加1次保級特權！此特權最多可累積2次。',
  h5_relegation_privilege_current: '你當前擁有保級特權：{count}次',
  h5_relegation_privilege_continuous: '當前已連續達到傳奇：{count}次',
  h5_relegation_privilege_max: '特權次數已達上限',
  h5_relegation_privilege_note:
    '注：使用保級特權後“連續達到傳奇“次數將重計。',
  h5_relegation_privilege_example1:
    '如果你連續3個月1號結算時等級達到VIP13以上：',
  h5_relegation_privilege_example2:
    '在第1、2個月1號，連續達到傳奇次數將分別顯示：1、2；',
  h5_relegation_privilege_example3:
    '第3個月連續傳奇次數將顯示0，“保級特權”次數加1。',
  h5_relegation_privilege_example4:
    '但如果在第2個月內使用了“保級特權”，連續達到傳奇次數將立即從2變為0，且第3個月1號連續達到傳奇次數為0。',
  other: '其他',
  h5_customer_long_time_no_see: '好久不見',
  h5_customer_old_tip: '有{total}人已經許久未給你下過單了，問候一下他吧',
  h5_customer_interaction_history: '互動歷史',
  h5_customer_chat_with: '找{pronoun}聊天',
  h5_customer_new_done: '已完成所有需要維護的新用戶',
  h5_customer_old_empty:
    '此處展示7-30天給您下單的客戶，當老朋友出現時記得打個招呼喔～',
  h5_customer_greeting_1: '哈囉～想玩就約我喔！',
  h5_customer_greeting_2: '闆闆你好～打遊戲嗎？',
  h5_customer_greeting_3: '你來啦～等你好久了> <',
  h5_customer_edit_message: '編輯要發送的內容',
  h5_customer_custom: '自定義',
  h5_customer_send: '發送',
  h5_customer_send_success: '發送成功',
  h5_customer_input_placeholder: '點擊輸入...',
  h5_customer_group_send: '一鍵群發',
  h5_customer_once_per_day: '每日一次機會',
  h5_customer_order_summary_prefix: '下过',
  h5_customer_order_summary_middle: '單，总價值',
  h5_customer_order_summary_suffix: '幣，',
  h5_customer_order_history: '下單紀錄',
  h5_customer_order_history_item_prefix: '{pronoun}給你的',
  h5_customer_order_history_item_middle: '下了{count}單，下單金額是',
  h5_player_topic_recommend_reason: '推薦理由：',
  h5_income_withdraw: '提領',
  h5_income_order_no: '訂單：{orderNo}',
  h5_income_balance: '餘額：{amount}',
  h5_income_repurchase_subsidy: '含回購補貼 +{amount}',
  h5_income_order_no_copied: '已複製訂單號',
  h5_income_revenue: '收入',
  h5_income_expense: '支出',
  h5_income_select_year_month: '選擇年月',
  h5_income_all_time: '全部時間',
  h5_income_year_month: '{year}年{month}月',
  h5_income_settlement_note: '正常訂單結算會在7個工作天內完成',
  h5_diamond_start_exchange: '開始兌換',
  h5_vip_member_outfit_permanent: '會員專屬裝扮（永久）',
  h5_vip_member_outfit_remark: '等級專屬頭像框、聊天氣泡、進場橫幅',
  h5_vip_coupon_title: '{count}張 {amount}幣折價券',
  h5_vip_monthly_claim_all: '每月1號後開放領取（全場通用）',
  h5_vip_need_points: '需會員積分{points}',
  h5_vip_diamond_title: '{amount}鑽',
  h5_vip_monthly_claim: '每月1號後開放領取',
  h5_vip_avatar_frame: '“{name}”頭像框（永久）',
  h5_vip_mount: '“{name}”坐騎',
  h5_vip_mount_permanent: '“{name}”坐騎（永久）',
  h5_vip_voice_room_enter: '語音廳進場時身份展現',
  h5_vip_voice_room_noble_enter: '語音廳進場時尊貴身份展現',
  h5_vip_unlock_level_gift: '解鎖等級專屬禮物“{name}”',
  h5_vip_level_gift: '等級專屬禮物“{name}”',
  h5_vip_home_recommend_hours: '收到禮物者獲得首頁推薦{hours}小時',
  h5_vip_app_cover_hours: '收到禮物者登入APP封面{hours}小時',
  h5_vip_exclusive_frame: '專屬頭像框“{name}”（永久）',
  h5_vip_gift_both_get: '送禮“{name}”後，送收禮雙方可獲得',
  h5_vip_beautiful_id: '{digits}位靚號',
  h5_vip_permanent_custom_frame: '永久自選專屬頭框*1',
  h5_vip_item_qili_fire: '綺麗焰火',
  h5_vip_item_bright_stars: '璀璨星辰',
  h5_vip_item_dream_car: '夢幻跑車',
  h5_vip_item_white_tiger: '白虎',
  h5_vip_item_extreme_car: '極限跑車',
  h5_vip_item_romantic_firework: '浪漫煙花',
  h5_vip_item_qilin: '麒麟',
  h5_vip_item_moved_for_you: '為你動情',
  h5_vip_item_crystal_shine: '晶耀',
  h5_vip_item_pyramid: '金字塔',
  h5_vip_item_legend: '傳奇',
  h5_vip_item_phoenix: '鳳凰',
  h5_vip_item_sky_city: '天空之城',
  h5_vip_item_legend_phoenix: '傳奇鳳凰',
  h5_vip_item_king_legend: '王者傳奇',
  h5_vip_item_dragon: '神龍',
  h5_vip_item_legend_throne: '傳奇王座',
  h5_vip_item_legend_dragon: '傳奇神龍',
  h5_vip_item_eternal_legend: '永恆傳奇',
  h5_vip_item_manifest_world: '顯世',
  h5_vip_item_nirvana: '涅槃',
  speak_now_rank_rule: '依據近三天送禮積分進行排名，聊天室送禮可獲得 5 倍積分',
  speak_now_confess: '我要告白',
  speak_now_select_target: '選擇要告白的對象',
  speak_now_search_placeholder: '輸入暱稱或 ID',
  speak_now_visit_profile: '訪問主頁',
  speak_now_recent_gifters: '最近送過禮物的人',
  speak_now_create_title: '想對誰表達心聲呢？',
  speak_now_select_confession_target: '選擇告白對象',
  speak_now_content_placeholder: '點擊輸入告白內容',
  speak_now_score: '心動值：{score}',
  speak_now_score_too_low: '心動值太低？立即',
  speak_now_send_more_gifts: '送 TA 更多禮物',
  speak_now_select_target_error: '請選擇告白對象！',
  speak_now_content_error: '請輸入告白內容！',
  speak_now_success: '告白成功！',
  newcomer_zone_title: '萌新',
  newcomer_zone_subtitle: '新來的陪玩師在這裡',
  newcomer_zone_latest: '最新發布',
  coupon_invitation_title: '請輸入邀請碼',
  coupon_invitation_placeholder: '填寫邀請碼',
  coupon_invitation_invalid: '填寫的邀請碼有誤，請檢查重試',
  coupon_phone_invalid: '手機號為空或不是台灣號碼',
  coupon_bind_failed: '綁定失敗',
  apullc_hero: '推薦好友獲得 3% 儲值酬謝',
  apullc_reward_summary_1: '我獲得 3% 儲值金酬謝和限定頭框',
  apullc_reward_summary_2: '好友獲得免費試玩券和 100 幣優惠券',
  apullc_detailed_rules: '詳細規則',
  apullc_rules: '如好友透過下方邀請碼註冊，我將獲得好友 60 天內每筆儲值的 3% 獎勵（單筆儲值若超過 3 萬，則按 3 萬計算）。邀請註冊累計達 15 人時，我將獲得活動限定頭像框「電馭叛客」（永久）。好友註冊時，將獲得總價值100幣滿額優惠券包。',
  apullc_link_copied: '已複製邀請鏈接',
  apullc_share_link: '或分享邀請鏈接',
  apullc_my_records: '我的活動紀錄', apullc_total_invited: '累計邀請用戶',
  apullc_cashback_total: '儲值現金回饋累計', apullc_points_total: '會員積分累計',
  apullc_limited_frame: '限定頭像框', apullc_frame_name: '電馭叛客', obtained: '已獲得',
  apullc_recent_rewards: '最近獎勵', apullc_no_records: '暫無記錄，快去邀請好友註冊吧～',
  apullc_bind_code: '補登優惠碼', claim: '領取',
  apullc_notes: '邀請獎勵發放需作業時間，請耐心等待。僅限綁定台灣手機號之帳戶為有效受邀用戶。以同台裝置或其他方式重複註冊的邀請無效。有任何疑問，請洽詢客服。',
  apullc_share_message: '一起來 Nicee 找到遊戲好夥伴！透過我的邀請連結註冊，新用戶可享免費一單及優惠券禮包。',
  apullc_clipboard_denied: '無權限讀取剪貼簿內容', apullc_got_frame: '獲得電馭叛客頭像框',
  apullc_recharge_reward: '{user} 儲值獲得 {amount} 幣',
  apullc_claim_offer_title: '領取專屬優惠！', apullc_kol_offer: '免費一單及價值 250 幣優惠券包',
  apullc_standard_offer: '免費一單及價值 100 幣優惠券包', apullc_bind_phone: '請綁定手機',
  phone_number: '手機號', sending: '發送中', apullc_resend_countdown: '重新傳送（{seconds}）', apullc_get_code: '獲取認證碼',
  verification_code: '驗證碼', invitation_code: '優惠碼', claim_offer: '領取優惠', nicee_platform_tagline: '優質遊戲陪玩平台',
  enter_phone_number: '請輸入手機號碼', phone_number_format_error: '手機號格式錯誤', enter_valid_phone_number: '請輸入正確的手機號碼',
  enter_invitation_code: '請輸入優惠碼', verification_code_error: '認證碼錯誤', apullc_success_reward: '恭喜您，已獲得推薦專屬獎勵！',
  apullc_success_login: '請使用手機號登入 Nicee 使用優惠！', apullc_google_play_opened: '已跳轉 Google Play', apullc_google_play_fallback: '無法使用 Google Play，將改為直接下載 APK。',
  view_full_image: '查看大圖', updating: '更新中', retry: '重試', generating: '生成中...', loading: '讀取中',
  vocality_voice_intro: '語音介紹', vocality_record_sample: '錄製聲音樣本', vocality_recommended_duration: '建議 7-10 秒', vocality_record_description: '請錄製 7-10 秒清晰語音，用於建立您的聲鑑卡',
  vocality_recording_tips: '錄製建議', vocality_tip_duration: '建議長度：7-10 秒', vocality_tip_clarity: '內容清晰、語速適中', vocality_tip_noise: '避免背景噪音干擾',
  vocality_card_preview: '聲鑑卡預覽', vocality_generating_official: '正在生成官方聲鑑卡...', vocality_loading_existing: '正在讀取既有聲鑑卡...', vocality_update_name: '更新名稱', vocality_profit_calculation: '收益計算方式',
  vocality_reused: '已復用', vocality_generated: '已生成', vocality_image_error: '圖片異常', vocality_regenerate_required: '需重新生成', vocality_pending: '待生成',
  vocality_record_intro_first: '請先錄製語音介紹', vocality_record_sample_first: '請先錄製聲音樣本', vocality_regenerate_card: '重新生成聲鑑卡', vocality_generate_card: '生成聲鑑卡',
  vocality_existing_image_missing: '既有聲鑑卡缺少官方圖片，請重新錄製生成後再提交。', vocality_loading_wait: '正在讀取既有聲鑑卡，請稍後', vocality_login_to_generate: '請先登入後再生成聲鑑卡', vocality_generating_wait: '聲鑑卡生成中，請稍候',
  vocality_generate_failed: '聲鑑卡生成失敗', vocality_image_generate_failed: '聲鑑卡圖片生成失敗，請稍後重試', vocality_generate_success: '聲鑑卡生成成功', vocality_generate_retry: '聲鑑卡生成失敗，請稍後重試',
  vocality_data_error: '聲鑑卡資料異常，請重新生成', vocality_enter_nickname: '請先填寫暱稱', vocality_login_to_update: '請先登入後再更新', vocality_name_update_failed: '聲鑑卡名稱更新失敗',
  vocality_image_update_failed: '聲鑑卡圖片更新失敗，請稍後重試', vocality_name_updated: '聲鑑卡名稱已更新', vocality_name_update_retry: '聲鑑卡名稱更新失敗，請稍後重試',
  vocality_image_missing: '聲鑑卡缺少官方圖片，請重新錄製生成後再提交。', vocality_image_load_failed: '官方聲鑑卡圖片載入失敗，請重試；若仍失敗，請重新錄製生成。', vocality_generate_first: '請先生成官方聲鑑卡',
  search: '搜索', request_failed: '請求失敗', network_error: '網路異常', vocality_audio_read_failed: '錄音檔讀取失敗，請重新錄製後再試',
  vocality_reject_not_human: '未偵測到清晰真人聲音，請重新錄製', vocality_reject_too_short: '聲音樣本時間太短，請錄製 8 秒以上', vocality_reject_too_noisy: '聲音樣本雜音較多，請在安靜環境重新錄製', vocality_reject_tts: '疑似合成語音，請使用本人真實聲音錄製', vocality_reject_default: '聲音樣本未通過認證，請重新錄製',
  apullc_rules_exact: '如好友透過下方邀請碼註冊，我將獲得好友 60 天內每筆儲值的 3% 獎勵（單筆儲值若超過 3 萬，則按 3 萬計算）。每成功邀請 1 位符合資格的新用戶，邀請人獲得 1500 會員積分。邀請註冊累計達 15 人時，我將獲得活動限定頭像框「電馭叛客」（永久）。好友註冊時，將獲得總價值100幣滿額優惠券包。',
  apullc_notes_exact: '邀請獎勵發放需作業時間，請耐心等待。僅限綁定台灣手機號之帳戶為有效受邀用戶。以同台裝置或其他方式重複註冊的邀請無效。有任何疑問，請洽詢客服。',
  select_level_first: '請選擇等級', enter_self_introduction: '請填寫自我介紹'
  ,jkoPay: {
    name: '街口支付', retry: '重新查詢付款結果', resultPending: '付款結果待確認',
    success: '付款成功', unconfirmed: '付款尚未確認', queryFailed: '暫時無法查詢付款結果',
    processing: '付款確認中', credited: '{asset}已成功入帳。',
    genericPending: '您的儲值請求已提交，我們正在向銀行確認交易結果。請稍候 1～5 分鐘，我們會於交易結果確認後另行通知。',
    unconfirmedDescription: '尚未查到街口付款成功結果，您可以稍後重新查詢，請勿重複付款。',
    queryFailedDescription: '系統暫時無法查詢街口付款結果，請稍後重新查詢，請勿重複付款。',
    processingDescription: '正在向街口支付確認付款結果，請勿重複付款。',
    nicee: 'Nicee 幣', diamond: '鑽石'
  }
};
export default tw;
